import axios from 'axios';
import StreamRecorder from 'CanvasRecorder';
import { gsap } from 'gsap';
import { PixiPlugin } from 'gsap/PixiPlugin.js';
import { findLastIndex } from 'lodash';
import moment from 'moment';
import * as PIXI from 'pixi.js-legacy';
import { Component } from 'react';
import { Overlay, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { Rnd } from 'react-rnd';
import AudioRepository from './AudioRepository';
import BackgroundMusicRepository from './BackgroundMusicRepository';
import Components from './ComponentIndex';
import { SceneEndTransition } from './EndTransitionGLSL';
import ImageRepository from './ImageRepository';
import { SceneStartTransition } from './StartTransitionGLSL';
import TextRepository from './TextRepository';
import TexturesMgmt from './TexturesMgmt';
import { clearCache, getFromCache } from './Utils';
import worker_script from './Workers/worker';
import { AnimatedGIF } from '@pixi/gif'; // Required for GIF support. Do not delete this line.

gsap.registerPlugin(PixiPlugin);
PixiPlugin.registerPIXI(PIXI);

//const webSocket = new WebSocket(`ws://localhost:8765`);
const MAX_FPS = 40;
const FRAME_GAP_MS = 1000 / MAX_FPS;
const SCENE_TIME_PX_MULTIPLIER = 10;
const RECORDING_PART_TIME = 5;
const DEFAULT_LINE_HEIGHT_FACTOR = 1.5;
const DEFAULT_LINE_PADDING_FACTOR = 0.1;
const PRESET_LEFT_RIGHT_PADDING = 0.04; //4% of total view area width
const PRESET_TOP_BOTTOM_PADDING = 0.07; //7% of total view area height

const activeRequests = new Set();
const MAX_CONCURRENT_REQUESTS = 30;

// Function to add a request to the queue
const addRequestToQueue = async (url, data, config) => {
  // Wait if the number of active requests reaches the limit
  while (activeRequests.size >= MAX_CONCURRENT_REQUESTS) {
    await new Promise((resolve) => setTimeout(resolve, 100)); // Polling delay
  }

  // Add the request to the active queue
  const promise = axios
    .post(url, data, config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {})
    .finally(() => {
      activeRequests.delete(promise); // Remove from active queue when done
    });

  activeRequests.add(promise);
  return promise;
};

export default class VideoPlayback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreview: false,
      showPlay: false,
      timeLineArrayElements: [],
      isBuffering: true,
      totalTime: 0,
      progress: 0,
      gotoScenenumber: -1,
      timeDone: 0,
      startScene: false,
    };

    ////To Disable all PIXI events as they interfere with FPS
    //Creating Pixi Application. Can pass view to this if we need to pass an already existing canvas
    if (props.recordVideo) {
      window.recordingStarted = true;
      window.framesCount = 0;
      window.frameUploadTasks = [];
      this.myWorker = new Worker(worker_script);
      this.offscreen = !this.props.webmrecording && !window.seleniumFrames ? new OffscreenCanvas(props.width, props.height) : null;
      if (window.seleniumRecordingVersion === 'v2') {
        this.offscreen = new OffscreenCanvas(props.width, props.height);
      }
      this.app = new PIXI.Application({
        forceCanvas: props.forceCanvas,
        width: props.width,
        height: props.height,
        backgroundAlpha: 0,
        view: this.offscreen,
      });
    } else {
      PIXI.settings.RESOLUTION = window.devicePixelRatio;
      // if(this.props.isTemplateGridPreview){
      //   PIXI.settings.TARGET_FPMS = 0;
      // }
      // PIXI.settings.ROUND_PIXELS =true;
      PIXI.settings.RENDER_OPTIONS.roundPixels = true;
      PIXI.settings.RENDER_OPTIONS.antialias = false;
      // PIXI.settings.GC_MAX_CHECK_COUNT = 100;
      // PIXI.settings.GC_MAX_IDLE = 600;
      this.app = new PIXI.Application({
        forceCanvas: props.forceCanvas,
        width: props.width,
        height: props.height,
        backgroundAlpha: 0,
        clearBeforeRender: true,
        autoDensity: true,
        autoStart: false,
        sharedTicker: true,
        sharedLoader: true,
      });
      // try {
      //   //this.app.ticker.stop();
      //   this.app.ticker.maxFPS = 1;
      //   this.app.ticker.destroy();
      // }
      // catch (e) {
      //   console.log(e);
      // }
    }
    this.recordVideo = props.recordVideo;
    this.isTemplatePreview = props.isTemplatePreview;
    this.forceCanvas = props.forceCanvas;
    this.width = props.width;
    this.height = props.height;
    this.pausedPlaybackState = {};
    this.framesCount = 0;
    this.sceneFrames = [];
    this.videoEnded = false;
    this.loadedTextures = [];
    this.frameDownloadLink = document.createElement('a');
    this.globalCurrentPlaybackStateObj = {};
    this.globalCurrentPlaybackStateObj = {};
    ///////////////////////////////////////
    this.index = 0;
    this.text = '';
    this.lastWord = null;
    ///////////////////////////////////////
    document.body.appendChild(this.frameDownloadLink);
    //this.isBuffering =true;
    this.isPlaying = false;
    this.animationRecordingEnabled = false;
    this.frameRecordingStartTime = null;
    this.baseCurrentPlaybackStateObj = {};
    if (this.props.videoJson && this.props.videoJson !== '') {
      this.LoadJsonResources(this.props.videoJson);
    }
    if (this.props.isTemplateGridPreview) {
      this.state.showPreview = true;
      this.state.startScene = true;
      this.state.isBuffering = false;
    }
  }

  componentWillUnmount() {
    try {
      this.isPlaying = false;
      if (this.app.ticker) {
        this.app.ticker.stop();
        this.app.ticker.destroy();
      }
    } catch (e) {}
  }

  LoadJsonResources(videoJson, SceneId) {
    if (videoJson.scenes.length == 1 && videoJson.scenes[0]) {
      var sceneToplay = videoJson.scenes[0];
      var scenes = [sceneToplay];
      TexturesMgmt.CreateTexturesFromScenes(scenes, null, null, this.loadedTextures);
    } else if (SceneId) {
      var sceneToplay = videoJson.scenes[SceneId - 1];
      var scenes = [sceneToplay];
      TexturesMgmt.CreateTexturesFromScenes(scenes, null, null, this.loadedTextures);
    } else {
      if (this.recordVideo) {
        TexturesMgmt.CreateTexturesFromScenes(videoJson.scenes, null, null, this.loadedTextures);
      } else {
        TexturesMgmt.CreateTexturesFromScenes(videoJson.scenes, 0, 10, this.loadedTextures);
      }
    }
    if (!this.recordVideo) {
      if (videoJson.audio && videoJson.audio.tts) {
        AudioRepository.Load(videoJson.audio.tts);
      }
      if (videoJson.audio && videoJson.audio.src) {
        BackgroundMusicRepository.Load(videoJson.audio.src, videoJson.audio.track_volume);
      }
    }
    if (this.props.brandingWatermarkUrl && this.props.brandingWatermarkUrl !== '') {
      ImageRepository.Load(this.props.brandingWatermarkUrl);
    }
    this.videoJson = videoJson;
    //this.videoJson.scenes = this.captureTimelineForScene(this.videoJson.scenes,SceneId);
    // try {
    //   this.app.ticker.stop();
    //   this.app.ticker.destroy();
    // }
    // catch (e) {
    //   console.log("LoadJsonResources",e);
    // }
  }

  logOnMediaError(log) {
    if (this.props.ErrorFromPreview) {
      log.videoElementcount = document.getElementsByTagName('video').length;
      log.audioElementcount = document.getElementsByTagName('audio').length;
      this.props.ErrorFromPreview(log);
    }
    //this.handleClose();
  }
  async WaitforResourceLoading(SceneId) {
    var loaded = false;
    var Payload = this.videoJson;
    var scenes = Payload.scenes;
    if (Payload.scenes.length == 1 && Payload.scenes[0]) {
      var sceneToplay = Payload.scenes[0];
      var scenes = [sceneToplay];
    } else if (SceneId) {
      var sceneToplay = Payload.scenes[SceneId - 1];
      var scenes = [sceneToplay];
    }
    if (Payload.audio && Payload.audio.src && !this.isTemplatePreview) {
      var BgMusic = BackgroundMusicRepository.GetFromCache([Payload.audio.src]);
    }
    if (Payload.audio && Payload.audio.tts && !this.isTemplatePreview) {
      var Audio = AudioRepository.GetFromCache([Payload.audio.tts]);
    }
    while (!loaded) {
      var runAgain = false;
      if (BgMusic) {
        if (BgMusic.error) {
          this.logOnMediaError({
            src: 'bgMusic',
            error: BgMusic.error.message,
            url: BgMusic.currentSrc,
            errorcode: BgMusic.error.code,
          });
          Payload.audio.src = null;
          //return null;
        }
        if (BgMusic && BgMusic.readyState) {
          runAgain = BgMusic.readyState < 2 ? true : false;
        }
      }
      if (Audio) {
        if (Audio.error) {
          this.logOnMediaError({
            src: 'bgAudio',
            error: Audio.error.message,
            url: Audio.currentSrc,
            errorcode: Audio.error.code,
          });
          Payload.audio.tts = null;
          //return null;
        }
        if (Audio && Audio.readyState) {
          runAgain = Audio.readyState < 2 ? true : false;
        }
      }
      for (let i = 0; i < scenes.length; i++) {
        var scene = scenes[i];
        //Looping through background sources in a scene
        for (let j = 0; j < scene.background.src.length; j++) {
          //Checking if texture ready
          if (!TexturesMgmt.CheckIfTextureValid(scene.background.src[j]) && scene.background.src[j].url && scene.background.src[j].url !== '') {
            var texture = TexturesMgmt.GetTexture(scene.background.src[j]);
            if (
              texture &&
              (texture.isLoadError ||
                (texture.baseTexture && texture.baseTexture.resource.source.error && texture.baseTexture.resource.source.error.message))
            ) {
              try {
                this.logOnMediaError({
                  src: 'bgVisual',
                  error: texture.baseTexture.resource.source.error.message,
                  url: texture.baseTexture.resource.source.src,
                  scene: i,
                  backGround: j,
                  errorcode: texture.baseTexture.resource.source.error.code,
                });
              } catch (e) {}
              TexturesMgmt.RemoveTexture(scene.background.src[j]);
              scene.background.src[j].url = null;
              scene.background.src[j].type = null;
              if (!this.recordVideo) {
                scene.background.color = 'rgba(0,0,0,255)';
              }
              //return null;
            }
            runAgain = true;
            break;
          }
        }
      }
      if (!runAgain) {
        loaded = true;
      } else {
        await this.sleep(300);
      }
    }
    return true;
  }

  captureTimelineForScene(scenes, SceneId) {
    const subsceneTotal = (subscenesArray) => subscenesArray.reduce((totalSub, subScene) => totalSub + subScene.time, 0);
    let scrollLeftForScenes = [0];
    let scrollLeftForSubscenes = [0];
    let scrollLeftScene = 0;
    let scrollLeftSubscene = 0;
    var timeLineArrayElements = [];
    let seekbarWidth = 0;
    if (scenes.length == 1 && scenes[0]) {
      var sceneToplay = scenes[0];
      var newSceneArray = [sceneToplay];
      scenes = newSceneArray;
    } else if (SceneId) {
      var sceneToplay = scenes[SceneId - 1];
      var newSceneArray = [sceneToplay];
      scenes = newSceneArray;
    }
    let elapsedTime = 0;
    let totaltime = scenes.reduce((total, scene) => total + (scene.sub_scenes.length > 0 ? subsceneTotal(scene.sub_scenes) : scene.time), 0);
    for (let i = 0; i < scenes.length; i++) {
      let subscenesArray = scenes[i].sub_scenes;
      if (subscenesArray.length === 0) {
        subscenesArray = [{ time: scenes[i].time }];
        if (i === 0) {
          // Intro scene
          subscenesArray[0].showSceneNumber = 'Scene 1 (Intro)';
        } else if (i === scenes.length - 1) {
          // Outro scene
          let lastSceneNumber = scenes.reduce((total, a) => total + (a.sub_scenes.length || 1), 0);
          subscenesArray[0].showSceneNumber = 'Scene ' + lastSceneNumber + ' (Outro)';
        }
      }
      let sceneTime = subsceneTotal(subscenesArray);
      scenes[i].startTime = elapsedTime;
      elapsedTime += sceneTime;
      var sceneTimePercentage = (sceneTime / totaltime) * 100 + '%';
      var sceneArrayObj = { index: i, percentage: sceneTimePercentage, time: sceneTime, subScenes: subscenesArray };
      timeLineArrayElements.push(sceneArrayObj);
      // width in px
      seekbarWidth += sceneTime * SCENE_TIME_PX_MULTIPLIER;

      // 1st element pos is 0, calculate scrollLeft px for all elements upto last but 1
      scrollLeftScene += sceneTime * SCENE_TIME_PX_MULTIPLIER;
      scrollLeftForScenes.push(scrollLeftScene);
      subscenesArray.forEach((subScene) => {
        scrollLeftSubscene += subScene.time * SCENE_TIME_PX_MULTIPLIER;
        scrollLeftForSubscenes.push(scrollLeftSubscene);
      });
    }
    scrollLeftForScenes.pop();
    scrollLeftForSubscenes.pop();

    let videoSeekContainer = document.querySelector('.preview-container .video-seek-container');
    if (videoSeekContainer) {
      if (seekbarWidth < videoSeekContainer.clientWidth) {
        seekbarWidth = '100%';
        for (let i = 0; i < timeLineArrayElements.length; i++) {
          for (let j = 0; j < timeLineArrayElements[i].subScenes.length; j++) {
            timeLineArrayElements[i].subScenes[j].percentage = (timeLineArrayElements[i].subScenes[j].time * 100) / totaltime + '%';
          }
        }
      }
    }

    this.setState({
      totalTime: totaltime,
      timeLineArrayElements: timeLineArrayElements,
      seekbarWidth,
      scrollLeftForScenes,
      scrollLeftForSubscenes,
    });
    return scenes;
  }

  Play(SceneId, startPlay = true) {
    this.setState({ showPreview: true, showPlay: false, progress: 0, timeDone: 0 }, () => {
      this.playvid(SceneId, startPlay);
    });
  }

  playvid(SceneId, startPlay = true) {
    this.videoJson.scenes = this.captureTimelineForScene(this.videoJson.scenes, SceneId);
    var Payload = this.videoJson;
    var CurrentPlaybackStateObj = {};
    this.sceneDurationRun = [];
    CurrentPlaybackStateObj.scenes = Payload.scenes;
    CurrentPlaybackStateObj.width = this.width;
    CurrentPlaybackStateObj.height = this.height;
    CurrentPlaybackStateObj.currentScaleX = CurrentPlaybackStateObj.width / Payload.output.width;
    CurrentPlaybackStateObj.currentScaleY = CurrentPlaybackStateObj.height / Payload.output.height;
    CurrentPlaybackStateObj.sceneNumber = this.props.playbackStartSceneNumber;
    CurrentPlaybackStateObj.CurrentFrameNumber = 0;
    //Load the background music
    if (!this.recordVideo && !this.isTemplatePreview) {
      if (Payload.audio && Payload.audio.src) {
        CurrentPlaybackStateObj.BackgroundMusic = BackgroundMusicRepository.GetFromCache([Payload.audio.src]);
        CurrentPlaybackStateObj.BackgroundMusic.volume = Payload.audio.track_volume;
        CurrentPlaybackStateObj.backgroundTrackVolume = Payload.audio.track_volume;
      }
      //Load Voice over
      if (Payload.audio && Payload.audio.tts) {
        CurrentPlaybackStateObj.Audio = AudioRepository.GetFromCache([Payload.audio.tts]);
      }
    }
    this.baseCurrentPlaybackStateObj = CurrentPlaybackStateObj;
    //Check initial resources needed for playback to start
    //Setting RunStartSceneWhenLoaded to true will run the start scene when neccesary items loaded
    //NumberOfItemsToCheck set to 3 we can change it as per requirement. can move to global
    this.globalCurrentPlaybackStateObj = CurrentPlaybackStateObj;
    this.CheckIfNextItemsLoaded(CurrentPlaybackStateObj, CurrentPlaybackStateObj.sceneNumber, 3, true, startPlay);
  }

  CheckIfNextItemsLoaded(CurrentPlaybackStateObj, StartCount, NumberOfItemsToCheck, RunStartSceneWhenLoaded, startPlay = true) {
    var scenes = CurrentPlaybackStateObj.scenes;
    var runAgain = false;
    if (StartCount == undefined) {
      StartCount = 0;
    }
    //Checking that NumberOfItemsToCheck does not exceed total number of scenes
    var preloadloopcount = scenes.length < StartCount + NumberOfItemsToCheck ? scenes.length : NumberOfItemsToCheck;
    //Checking if audio ready
    if (!this.recordVideo) {
      if (CurrentPlaybackStateObj.BackgroundMusic) {
        if (CurrentPlaybackStateObj.BackgroundMusic.error) {
          this.logOnMediaError({
            src: 'bgMusic',
            error: CurrentPlaybackStateObj.BackgroundMusic.error.message,
            url: CurrentPlaybackStateObj.BackgroundMusic.currentSrc,
            errorcode: CurrentPlaybackStateObj.BackgroundMusic.error.code,
          });
          CurrentPlaybackStateObj.BackgroundMusic = null;
          //return null;
        }
        if (CurrentPlaybackStateObj.BackgroundMusic) {
          runAgain = CurrentPlaybackStateObj.BackgroundMusic.readyState < 2 ? true : false;
        }
      }
      if (CurrentPlaybackStateObj.Audio) {
        if (CurrentPlaybackStateObj.Audio.error) {
          this.logOnMediaError({
            src: 'bgAudio',
            error: CurrentPlaybackStateObj.Audio.error.message,
            url: CurrentPlaybackStateObj.Audio.currentSrc,
            errorcode: CurrentPlaybackStateObj.Audio.error.code,
          });
          CurrentPlaybackStateObj.Audio = null;
          //return null;
        }
        if (CurrentPlaybackStateObj.Audio) {
          runAgain = CurrentPlaybackStateObj.Audio.readyState < 2 ? true : false;
        }
      }
    }
    if (!runAgain) {
      //Looping through scenes
      for (let i = StartCount; i < preloadloopcount; i++) {
        var scene = scenes[i];
        //Looping through background sources in a scene
        for (let j = 0; j < scene.background.src.length; j++) {
          //Checking if texture ready
          if (
            scene.background.src[j] &&
            !TexturesMgmt.CheckIfTextureValid(scene.background.src[j]) &&
            scene.background.src[j].url &&
            scene.background.src[j].url !== ''
          ) {
            var texture = TexturesMgmt.GetTexture(scene.background.src[j]);
            if (
              texture &&
              (texture.isLoadError ||
                (texture.baseTexture && texture.baseTexture.resource.source.error && texture.baseTexture.resource.source.error.message))
            ) {
              try {
                this.logOnMediaError({
                  src: 'bgVisual',
                  error: texture.baseTexture.resource.source.error.message,
                  url: texture.baseTexture.resource.source.src,
                  scene: i,
                  backGround: j,
                  errorcode: texture.baseTexture.resource.source.error.code,
                });
              } catch (e) {}
              TexturesMgmt.RemoveTexture(scene.background.src[j]);
              scene.background.src[j].url = null;
              scene.background.src[j].type = null;
              if (!this.recordVideo) {
                scene.background.color = 'rgba(0,0,0,255)';
              }
              //return null;
            }
            runAgain = true;
            break;
          } else if (
            scene.background.src[j] &&
            TexturesMgmt.CheckIfTextureValid(scene.background.src[j]) &&
            (!scene.background.src[j].blurUrl || scene.background.src[j].blurUrl === '')
          ) {
            var backgroundTexture = TexturesMgmt.GetTexture(scene.background.src[j]);
            let backgroundSource = scene.background.src[j];
            if (backgroundTexture) {
              if (backgroundSource.mode === 'fit') {
                try {
                  this.generateBlurImageforRecording(backgroundTexture, CurrentPlaybackStateObj, backgroundSource);
                } catch (e) {
                  let bgRecreate = backgroundTexture.clone();
                  let offscreenForBGBlur = new OffscreenCanvas(this.props.width, this.props.height);
                  let BGBlurApp = new PIXI.Application({
                    forceCanvas: true,
                    width: this.props.width,
                    height: this.props.height,
                    backgroundAlpha: 0,
                    view: offscreenForBGBlur,
                  });
                  var blurBackgroundSprite = this.GenerateBackgroundSprite(
                    bgRecreate,
                    CurrentPlaybackStateObj.width,
                    CurrentPlaybackStateObj.height,
                    'crop',
                    backgroundSource.frame,
                    CurrentPlaybackStateObj.currentScaleX,
                    CurrentPlaybackStateObj.currentScaleY
                  );
                  BGBlurApp.stage.addChild(blurBackgroundSprite);
                  BGBlurApp.render();
                  let bitmap = offscreenForBGBlur.transferToImageBitmap();
                  let newbg = PIXI.Texture.from(bitmap);
                  try {
                    this.generateBlurImageforRecording(newbg, CurrentPlaybackStateObj, backgroundSource);
                  } catch {}
                  backgroundTexture.blurBackgroundSpriteImage = newbg.blurBackgroundSpriteImage;
                  try {
                    offscreenForBGBlur = null;
                    BGBlurApp.stop();
                    BGBlurApp.destroy(true);
                    BGBlurApp = null;
                  } catch (e) {}
                }
              }
            } else {
              runAgain = true;
              break;
            }
          }
          if (
            scene.background.src[j] &&
            scene.background.src[j].url &&
            scene.background.src[j].url !== '' &&
            scene.background.src[j].mode == 'fit' &&
            scene.background.src[j].blurUrl &&
            scene.background.src[j].blurUrl !== ''
          ) {
            let bgSrc = {
              ...scene.background.src[j],
              url: scene.background.src[j].blurUrl,
              asset_id: scene.background.src[j].asset_id ? scene.background.src[j].asset_id + '_blur' : null,
            };
            if (!TexturesMgmt.CheckIfTextureValid(bgSrc)) {
              var texture = TexturesMgmt.GetTexture(bgSrc);
              if (
                texture &&
                (texture.isLoadError ||
                  (texture.baseTexture && texture.baseTexture.resource.source.error && texture.baseTexture.resource.source.error.message))
              ) {
                try {
                  this.logOnMediaError({
                    src: 'bgVisual',
                    error: texture.baseTexture.resource.source.error.message,
                    url: texture.baseTexture.resource.source.src,
                    scene: i,
                    backGround: j,
                    errorcode: texture.baseTexture.resource.source.error.code,
                  });
                } catch (e) {}
                TexturesMgmt.RemoveTexture(bgSrc);
                bgSrc.url = null;
                bgSrc.type = null;
                if (!this.recordVideo) {
                  scene.background.color = 'rgba(0,0,0,255)';
                }
                //return null;
              }
              runAgain = true;
              break;
            } else {
              var texture = TexturesMgmt.GetTexture(bgSrc);
              var backgroundTexture = TexturesMgmt.GetTexture(scene.background.src[j]);
              backgroundTexture.blurBackgroundFromSourceTexture = texture;
            }
          }
          if (!runAgain) {
            if (
              scene.background.src[j] &&
              scene.background.logo &&
              scene.background.logo.src &&
              scene.background.logo &&
              scene.background.logo.src !== ''
            ) {
              var logoTexture = TexturesMgmt.GetImageTexture(scene.background.logo.src);
              if (!logoTexture || !logoTexture.valid) {
                runAgain = true;
                break;
              }
            }
          }
        }
        if (runAgain) {
          break;
        }
      }
    }
    if (this.props.brandingWatermarkUrl && this.props.brandingWatermarkUrl !== '') {
      var brandingWatermarkTexture = ImageRepository.GetTexture(this.props.brandingWatermarkUrl);
      if (brandingWatermarkTexture && !brandingWatermarkTexture.valid) {
        runAgain = true;
      }
    }
    if (runAgain) {
      //Checking every 200ms
      setTimeout(() => this.CheckIfNextItemsLoaded(CurrentPlaybackStateObj, StartCount, NumberOfItemsToCheck, RunStartSceneWhenLoaded), 200);
    } else {
      if (RunStartSceneWhenLoaded) {
        setTimeout(() => {
          if (this.props.webmrecording) {
            if (!this.canvasStream) {
              this.canvasStream = this.app.view.captureStream(25);
            }
            if (!this.streamRecorder) {
              this.streamRecorder = new StreamRecorder(this.canvasStream, 8000000);
              this.streamRecorder.start();
            }
          }
        }, 50);
        //We can play the initial part of video
        //Setting the first scene
        this.setState({ startScene: true });
        try {
          this.app.start();
        } catch (e) {}
        this.setScene(0, CurrentPlaybackStateObj, true, null, null, startPlay);
      }
      //return true;
    }
  }
  generateBlurImageforRecording(backgroundTexture, CurrentPlaybackStateObj, backgroundSource) {
    let offscreenForBGBlur = new OffscreenCanvas(this.props.width, this.props.height);
    let BGBlurApp = new PIXI.Application({
      forceCanvas: false,
      width: this.props.width,
      height: this.props.height,
      backgroundAlpha: 0,
      view: offscreenForBGBlur,
    });
    var blurBackgroundSprite = this.GenerateBackgroundSprite(
      backgroundTexture,
      CurrentPlaybackStateObj.width,
      CurrentPlaybackStateObj.height,
      'crop',
      backgroundSource.frame,
      CurrentPlaybackStateObj.currentScaleX,
      CurrentPlaybackStateObj.currentScaleY
    );
    blurBackgroundSprite.filters = [new PIXI.filters.BlurFilter(7)];
    BGBlurApp.stage.addChild(blurBackgroundSprite);
    BGBlurApp.render();
    let bitmap = offscreenForBGBlur.transferToImageBitmap();
    // let sp = PIXI.Sprite.from(bitmap);
    // sp.width = this.props.width;
    // sp.height = this.props.height;
    backgroundTexture.blurBackgroundSpriteImage = bitmap;
    try {
      offscreenForBGBlur = null;
      BGBlurApp.stop();
      BGBlurApp.destroy(true);
      BGBlurApp = null;
    } catch (e) {}
  }

  pauseOnWaiting() {
    console.log('pauseOnWaiting');
    this.isPlaying = false;
    this.setState({ showPlay: true, isBuffering: true });
  }
  playOnReady() {
    console.log('playOnReady');
    if (this.state.isBuffering) {
      this.playVideo();
    }
  }

  setScene(SceneIndex, CurrentPlaybackStateObj, PlayAudio, isSeek, iteration, startPlay = true) {
    //var currentDate = Date.now();
    //If the video of previous scene/backgroundsource is playing we need to ause/stop it before loading next scene
    if (
      CurrentPlaybackStateObj.CurrentBackGroundSource &&
      CurrentPlaybackStateObj.CurrentBackGroundSource.type === 'video' &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source
    ) {
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.pause();
    }
    CurrentPlaybackStateObj.isTemplateGridPreview = this.props.isTemplateGridPreview;
    var sceneobj = { index: SceneIndex, durationRun: 0, subscenes: [] };
    this.sceneDurationRun.push(sceneobj);
    let blurDiv = document.getElementById('blurBgDiv');
    if (SceneIndex < CurrentPlaybackStateObj.scenes.length && this.app.stage) {
      this.videoEnded = false;
      //Clean the stage for setting up new scene
      if (!iteration) {
        this.CleanupScene(CurrentPlaybackStateObj);
        this.CleanupSubScene(CurrentPlaybackStateObj);
        if (blurDiv) {
          while (blurDiv.firstChild) {
            blurDiv.removeChild(blurDiv.lastChild);
          }
        }
      }
      if (!CurrentPlaybackStateObj.scenes[SceneIndex].startTime && CurrentPlaybackStateObj.scenes[SceneIndex].startTime != 0) {
        CurrentPlaybackStateObj.scenes[SceneIndex].startTime =
          CurrentPlaybackStateObj.scenes[SceneIndex - 1].startTime + CurrentPlaybackStateObj.scenes[SceneIndex - 1].time;
      }
      //Setting up the scene
      CurrentPlaybackStateObj.CurrentSceneIndex = SceneIndex;
      CurrentPlaybackStateObj.CurrentScene = CurrentPlaybackStateObj.scenes[SceneIndex];
      var progress = (CurrentPlaybackStateObj.CurrentScene.startTime / this.state.totalTime) * 100;
      this.setState({ progress: progress + '%', timeDone: CurrentPlaybackStateObj.CurrentScene.startTime });
      //CurrentPlaybackStateObj.CurrentSceneStartTime = currentDate;
      if (!this.recordVideo) {
        for (let i = 0; i < CurrentPlaybackStateObj.CurrentScene.sub_scenes.length; i++) {
          let subScene = CurrentPlaybackStateObj.CurrentScene.sub_scenes[i];
          if (subScene.displayItems && subScene.displayItems.length > 0) {
            for (let j = 0; j < subScene.displayItems.length; j++) {
              let dispItem = subScene.displayItems[j];
              if (dispItem.type == 'visual') {
                let parsedUrl = new URL(dispItem.src);
                dispItem.src = parsedUrl.toString();
                let element = getFromCache(dispItem.id ? dispItem.src + dispItem.id : dispItem.src);
                if (!element) {
                  element = TexturesMgmt.GetTexture({
                    url: dispItem.id ? dispItem.src + dispItem.id : dispItem.src,
                    type: dispItem.visualType,
                  });
                }
                if (!element && dispItem.src && dispItem.src !== '') {
                  TexturesMgmt.CreateTexturesFromScenes(CurrentPlaybackStateObj.scenes, SceneIndex, SceneIndex + 5, this.loadedTextures);
                  this.setState({ isBuffering: true });
                  setTimeout(() => {
                    this.setScene(SceneIndex, CurrentPlaybackStateObj, true, isSeek, 1);
                  }, 200);
                  return null;
                } else if (!element || !((element.texture && element.texture.valid) || element.valid)) {
                  setTimeout(() => {
                    this.setScene(SceneIndex, CurrentPlaybackStateObj, true, isSeek, 1);
                  }, 200);
                  return null;
                }
              }
            }
          }
        }
        for (let i = 0; i < CurrentPlaybackStateObj.CurrentScene.background.src.length; i++) {
          var backgroundSource = CurrentPlaybackStateObj.scenes[SceneIndex].background.src[i];
          if (backgroundSource) {
            var backgroundTexture = TexturesMgmt.GetTexture(backgroundSource);
            if (!backgroundTexture && backgroundSource.url && backgroundSource.url !== '') {
              TexturesMgmt.CreateTexturesFromScenes(CurrentPlaybackStateObj.scenes, SceneIndex, SceneIndex + 5, this.loadedTextures);
              this.setState({ isBuffering: true });
              setTimeout(() => {
                this.setScene(SceneIndex, CurrentPlaybackStateObj, true, isSeek, 1);
              }, 200);
              return null;
            } else if (!TexturesMgmt.CheckIfTextureValid(backgroundSource) && backgroundSource.url && backgroundSource.url !== '') {
              //this.setState({ isBuffering: true });
              if (
                backgroundTexture &&
                (backgroundTexture.isLoadError ||
                  (backgroundTexture.baseTexture &&
                    backgroundTexture.baseTexture.resource.source.error &&
                    backgroundTexture.baseTexture.resource.source.error.message))
              ) {
                try {
                  this.logOnMediaError({
                    src: 'bgVisual',
                    error: backgroundTexture.baseTexture.resource.source.error.message,
                    url: backgroundTexture.baseTexture.resource.source.src,
                    scene: SceneIndex,
                    backGround: i,
                    errorcode: backgroundTexture.baseTexture.resource.source.error.code,
                  });
                } catch (e) {}
                TexturesMgmt.RemoveTexture(backgroundSource);
                backgroundSource.url = null;
                backgroundSource.type = null;
                if (!this.recordVideo) {
                  CurrentPlaybackStateObj.scenes[SceneIndex].background.color = 'rgba(0,0,0,255)';
                }
                //return null;
              } else {
                setTimeout(() => {
                  this.setScene(SceneIndex, CurrentPlaybackStateObj, true, isSeek, 1);
                }, 200);
                return null;
              }
            }
          }
        }
      }
      //Working on Background
      let SceneContainer = new PIXI.Container();
      CurrentPlaybackStateObj.CurrentSceneContainer = SceneContainer;
      //adding Background color in scene container
      if (
        CurrentPlaybackStateObj.CurrentScene.background.src[0] &&
        CurrentPlaybackStateObj.CurrentScene.background.src[0].url &&
        CurrentPlaybackStateObj.CurrentScene.background.src[0].url !== '' &&
        backgroundSource &&
        backgroundSource.type !== 'image' &&
        backgroundSource.type !== 'video'
      ) {
        SceneContainer.addChild(this.GenerateBackgroundGraphic('rgba(0,0,0,255)', CurrentPlaybackStateObj.width, CurrentPlaybackStateObj.height));
      }
      if (
        CurrentPlaybackStateObj.CurrentScene.background.color &&
        !(CurrentPlaybackStateObj.CurrentScene.background.src[0].url && CurrentPlaybackStateObj.CurrentScene.background.src[0].url !== '')
      ) {
        SceneContainer.addChild(
          this.GenerateBackgroundGraphic(
            CurrentPlaybackStateObj.CurrentScene.background.color,
            CurrentPlaybackStateObj.width,
            CurrentPlaybackStateObj.height
          )
        );
        if (CurrentPlaybackStateObj.CurrentScene.background?.colorOverlay && !CurrentPlaybackStateObj.CurrentScene.background?.colorOverlay?.hide) {
          let colorOverlay = CurrentPlaybackStateObj.CurrentScene.background?.colorOverlay;
          let overlay = this.GenerateBackgroundGraphic(colorOverlay.bgColor, CurrentPlaybackStateObj.width, CurrentPlaybackStateObj.height);
          overlay.alpha = colorOverlay.opacity;
          SceneContainer.addChild(overlay);
        }
      }
      //Getting the backround for scene
      CurrentPlaybackStateObj.sceneBackgroundSources = [];
      CurrentPlaybackStateObj.sceneBackgroundTextures = [];
      CurrentPlaybackStateObj.sceneBackgroundSprites = [];
      CurrentPlaybackStateObj.CurrentBackGroundSource = null;
      CurrentPlaybackStateObj.CurrentBackgroundTexture = null;
      CurrentPlaybackStateObj.CurrentBackgroundSprite = null;
      var bgSourceTimeCumulative = 0;
      for (let i = 0; i < CurrentPlaybackStateObj.scenes[SceneIndex].background.src.length; i++) {
        var backgroundSource = CurrentPlaybackStateObj.scenes[SceneIndex].background.src[i];
        if (backgroundSource && backgroundSource.url && backgroundSource.url !== '') {
          if (
            backgroundSource.start !== null &&
            backgroundSource.end !== null &&
            CurrentPlaybackStateObj.scenes[SceneIndex].background.src.length > 1
          ) {
            bgSourceTimeCumulative = bgSourceTimeCumulative + backgroundSource.end - backgroundSource.start;
            backgroundSource.endTime = bgSourceTimeCumulative;
          }
          var backgroundTexture = TexturesMgmt.GetTexture(backgroundSource);
          if (
            backgroundTexture &&
            (backgroundTexture.isLoadError ||
              (backgroundTexture.baseTexture &&
                backgroundTexture.baseTexture.resource.source.error &&
                backgroundTexture.baseTexture.resource.source.error.message))
          ) {
            try {
              this.logOnMediaError({
                src: 'bgVisual',
                error: backgroundTexture.baseTexture.resource.source.error.message,
                url: backgroundTexture.baseTexture.resource.source.src,
                scene: SceneIndex,
                backGround: i,
                errorcode: backgroundTexture.baseTexture.resource.source.error.code,
              });
            } catch (e) {}
            TexturesMgmt.RemoveTexture(backgroundSource);
            backgroundSource.url = null;
            backgroundSource.type = null;
            if (!this.recordVideo) {
              CurrentPlaybackStateObj.scenes[SceneIndex].background.color = 'rgba(0,0,0,255)';
            }
            //return null;
          }
          //backgroundTexture.baseTexture.resource.source.width = CurrentPlaybackStateObj.width;
          //backgroundTexture.baseTexture.resource.source.height = CurrentPlaybackStateObj.height;
          if (!this.recordVideo) {
            let bgBlurElement = backgroundTexture.baseTexture.resource.source.cloneNode(true);
            if (bgBlurElement.tagName == 'CANVAS') {
              bgBlurElement = new Image(this.props.width, this.props.height);
              bgBlurElement.src = backgroundSource.url;
            }
            bgBlurElement.style.position = 'absolute';
            bgBlurElement.style.top = '0px';
            //bgBlurElement.style.filter = 'blur(8px)';
            //bgBlurElement.style.webkitFilter = 'blur(8px)';
            bgBlurElement.style.height = this.props.height;
            bgBlurElement.style.width = this.props.width;
            bgBlurElement.style.objectFit = 'cover';
            if (!this.props.isTemplateGridPreview && blurDiv && i == 0) {
              if (backgroundTexture.baseTexture.resource.source.currentTime && backgroundTexture.baseTexture.resource.source.currentTime > 0) {
                bgBlurElement.currentTime = backgroundTexture.baseTexture.resource.source.currentTime;
              } else {
                bgBlurElement.currentTime = 0.1;
              }
              blurDiv.appendChild(bgBlurElement);
            }
          }
          var backgroundSprite = this.GenerateBackgroundSprite(
            backgroundTexture,
            CurrentPlaybackStateObj.width,
            CurrentPlaybackStateObj.height,
            backgroundSource.mode,
            backgroundSource.frame,
            CurrentPlaybackStateObj.currentScaleX,
            CurrentPlaybackStateObj.currentScaleY
          );
          backgroundSprite.visible = false;
          if (backgroundSource.mode == 'fit' && this.recordVideo && backgroundTexture.blurBackgroundSpriteImage) {
            let sp = PIXI.Sprite.from(backgroundTexture.blurBackgroundSpriteImage);
            let scale = Math.max(this.props.width / sp.width, this.props.height / sp.height);
            sp.width = sp.width * scale;
            sp.height = sp.height * scale;
            if (this.props.width > sp.width) {
              sp.x = this.props.width / 2 - sp.width / 2;
              sp.y = this.props.height / 2 - sp.height / 2;
            } else {
              sp.x = this.props.width / 2 - sp.width / 2;
              sp.y = this.props.height / 2 - sp.height / 2;
            }
            SceneContainer.addChild(sp);
          }
          if (backgroundSource.mode == 'fit' && this.recordVideo && backgroundTexture.blurBackgroundFromSourceTexture) {
            let sp = PIXI.Sprite.from(backgroundTexture.blurBackgroundFromSourceTexture);
            let scale = Math.max(this.props.width / sp.width, this.props.height / sp.height);
            sp.width = sp.width * scale;
            sp.height = sp.height * scale;
            if (this.props.width > sp.width) {
              sp.x = this.props.width / 2 - sp.width / 2;
              sp.y = this.props.height / 2 - sp.height / 2;
            } else {
              sp.x = this.props.width / 2 - sp.width / 2;
              sp.y = this.props.height / 2 - sp.height / 2;
            }
            SceneContainer.addChild(sp);
          }
          SceneContainer.addChild(backgroundSprite);
          if (CurrentPlaybackStateObj.CurrentScene.background?.colorOverlay && !CurrentPlaybackStateObj.CurrentScene.background?.colorOverlay?.hide) {
            let colorOverlay = CurrentPlaybackStateObj.CurrentScene.background?.colorOverlay;
            let overlay = this.GenerateBackgroundGraphic(colorOverlay.bgColor, CurrentPlaybackStateObj.width, CurrentPlaybackStateObj.height);
            overlay.alpha = colorOverlay.opacity;
            SceneContainer.addChild(overlay);
          }
          CurrentPlaybackStateObj.sceneBackgroundSources.push(backgroundSource);
          CurrentPlaybackStateObj.sceneBackgroundTextures.push(backgroundTexture);
          CurrentPlaybackStateObj.sceneBackgroundSprites.push(backgroundSprite);
          if (i == 0) {
            backgroundSprite.visible = true;
            CurrentPlaybackStateObj.CurrentBackGroundSource = backgroundSource;
            CurrentPlaybackStateObj.CurrentBackgroundTexture = backgroundTexture;
            CurrentPlaybackStateObj.CurrentBackgroundSprite = backgroundSprite;
            CurrentPlaybackStateObj.CurrentBackgroundIndex = 0;
            if (
              CurrentPlaybackStateObj.CurrentScene.background.bg_animation &&
              CurrentPlaybackStateObj.CurrentScene.background.bg_animation.animation !== '' &&
              CurrentPlaybackStateObj.CurrentBackGroundSource.mode !== 'fit' &&
              CurrentPlaybackStateObj.CurrentBackGroundSource.type !== 'video'
            ) {
              const ComponentToRender = Components[CurrentPlaybackStateObj.CurrentScene.background.bg_animation.animation];
              if (ComponentToRender) {
                var BGAnimation = ComponentToRender.Animate(CurrentPlaybackStateObj.CurrentBackgroundSprite, {
                  duration: CurrentPlaybackStateObj.CurrentScene.totalSceneTime
                    ? CurrentPlaybackStateObj.CurrentScene.totalSceneTime
                    : CurrentPlaybackStateObj.CurrentScene.time,
                  sceneStartTime: CurrentPlaybackStateObj.CurrentScene.loopStartTime,
                });
                CurrentPlaybackStateObj.BackgroundAnimations.push(BGAnimation);
              }
            }
          }
        }
      }
      //   var CurrentBackGroundSource = CurrentPlaybackStateObj.scenes[SceneIndex].background.src[0];
      //   if(CurrentBackGroundSource){
      //   if (CurrentBackGroundSource.url && CurrentBackGroundSource.url !== '') {
      //     var CurrentBackgroundTexture = TexturesMgmt.GetTexture(CurrentBackGroundSource);
      //     CurrentBackgroundTexture.baseTexture.resource.source.width= CurrentPlaybackStateObj.width;
      //     CurrentBackgroundTexture.baseTexture.resource.source.height= CurrentPlaybackStateObj.height;
      //     //adding Background image/video in scene container
      //     var CurrentBackgroundSprite = this.GenerateBackgroundSprite(CurrentBackgroundTexture, CurrentPlaybackStateObj.width, CurrentPlaybackStateObj.height, CurrentBackGroundSource.mode, CurrentBackGroundSource.frame, CurrentPlaybackStateObj.currentScaleX, CurrentPlaybackStateObj.currentScaleY);
      //     SceneContainer.addChild(CurrentBackgroundSprite);
      //     CurrentPlaybackStateObj.CurrentBackGroundSource = CurrentBackGroundSource;
      //     CurrentPlaybackStateObj.CurrentBackgroundTexture = CurrentBackgroundTexture;
      //     CurrentPlaybackStateObj.CurrentBackgroundSprite = CurrentBackgroundSprite;
      //     //Animating Background
      //     if (CurrentPlaybackStateObj.CurrentScene.background.bg_animation && CurrentPlaybackStateObj.CurrentScene.background.bg_animation.animation !== '' && CurrentBackGroundSource.mode !== 'fit' && CurrentPlaybackStateObj.CurrentBackGroundSource.type !== 'video') {
      //       const ComponentToRender = Components[CurrentPlaybackStateObj.CurrentScene.background.bg_animation.animation];
      //       if (ComponentToRender) {
      //         var BGAnimation = ComponentToRender.Animate(CurrentBackgroundSprite, { duration: CurrentPlaybackStateObj.CurrentScene.time });
      //         CurrentPlaybackStateObj.BackgroundAnimations.push(BGAnimation);
      //       }
      //     }
      //   }
      // }
      //Adding BgMask
      if (CurrentPlaybackStateObj.CurrentScene.background.bg_mask) {
        var bgMask = this.GenerateBackgroundGraphic(
          CurrentPlaybackStateObj.CurrentScene.background.bg_mask.color,
          parseFloat(CurrentPlaybackStateObj.CurrentScene.background.bg_mask.area) * CurrentPlaybackStateObj.width,
          CurrentPlaybackStateObj.height
        );
        bgMask.x = 0;
        if (CurrentPlaybackStateObj.CurrentScene.background.bg_mask.side !== 'left') {
          bgMask.x = CurrentPlaybackStateObj.width - bgMask.width;
        }
        SceneContainer.addChild(bgMask);
      }
      ///////////////
      //Adding logo
      if (
        CurrentPlaybackStateObj.CurrentScene.background.logo &&
        CurrentPlaybackStateObj.CurrentScene.background.logo.src &&
        CurrentPlaybackStateObj.CurrentScene.background.logo.src !== ''
      ) {
        var CurrentLogoTexture = TexturesMgmt.GetImageTexture(CurrentPlaybackStateObj.CurrentScene.background.logo.src);
        if (CurrentLogoTexture && !this.props.isTemplateGridPreview) {
          var CurrentLogoSprite = this.GenerateLogoSprite(
            CurrentLogoTexture,
            CurrentPlaybackStateObj.width,
            CurrentPlaybackStateObj.height,
            CurrentPlaybackStateObj.CurrentScene.background.logo.location,
            CurrentPlaybackStateObj.CurrentScene.background.logo.location_y,
            CurrentPlaybackStateObj.currentScaleY,
            CurrentPlaybackStateObj.CurrentScene.background.logo.size,
            CurrentPlaybackStateObj.CurrentScene.background.logo.opacity,
            CurrentPlaybackStateObj.CurrentScene.background.logo.width,
            CurrentPlaybackStateObj.CurrentScene.background.logo.leftCoordinate,
            CurrentPlaybackStateObj.CurrentScene.background.logo.topCoordinate
          );
          CurrentPlaybackStateObj.CurrentLogoSprite = CurrentLogoSprite;
          if (
            CurrentPlaybackStateObj.CurrentScene.background.logo_animation &&
            CurrentPlaybackStateObj.CurrentScene.background.logo_animation.animation !== ''
          ) {
            const ComponentToRender = Components[CurrentPlaybackStateObj.CurrentScene.background.logo_animation.animation];
            if (ComponentToRender) {
              var logoAnimation = ComponentToRender.Animate(CurrentLogoSprite, {
                speed: CurrentPlaybackStateObj.CurrentScene.background.logo_animation.animation.speed,
                canvasHeight: CurrentPlaybackStateObj.height,
                canvasWidth: CurrentPlaybackStateObj.width,
              });
              CurrentPlaybackStateObj.BackgroundAnimations.push(logoAnimation);
            }
          }
        }
      }
      ///Adding branding Watrmark
      if (this.props.brandingWatermarkUrl && this.props.brandingWatermarkUrl !== '') {
        var brandingWatermarkTexture = ImageRepository.GetTexture(this.props.brandingWatermarkUrl);
        if (brandingWatermarkTexture) {
          var location;
          if (
            CurrentPlaybackStateObj.CurrentScene.background.logo &&
            CurrentPlaybackStateObj.CurrentScene.background.logo.src &&
            CurrentPlaybackStateObj.CurrentScene.background.logo.src !== ''
          ) {
            location = CurrentPlaybackStateObj.CurrentScene.background.logo.location;
          }
          let brandingWatermarkSprite = this.GenerateWatermarkSprite(
            brandingWatermarkTexture,
            CurrentPlaybackStateObj.width,
            CurrentPlaybackStateObj.height,
            location
          );
          SceneContainer.addChild(brandingWatermarkSprite);
        }
      }
      //Adding Scene Container to Stage
      this.app.stage.addChild(SceneContainer);
      //Adding SubScene
      CurrentPlaybackStateObj = this.setSubScene(0, CurrentPlaybackStateObj, startPlay);
      if (
        CurrentPlaybackStateObj.CurrentLogoSprite &&
        CurrentPlaybackStateObj.CurrentScene.background.logo &&
        CurrentPlaybackStateObj.CurrentScene.background.logo.src &&
        CurrentPlaybackStateObj.CurrentScene.background.logo.src != '' &&
        !this.props.isTemplateGridPreview
      ) {
        this.app.stage.addChild(CurrentPlaybackStateObj.CurrentLogoSprite);
      }

      if (
        CurrentPlaybackStateObj.CurrentBackGroundSource &&
        CurrentPlaybackStateObj.CurrentBackGroundSource.type === 'video' &&
        CurrentPlaybackStateObj.CurrentBackgroundTexture &&
        CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture
      ) {
        if (CurrentPlaybackStateObj.CurrentBackGroundSource.start || CurrentPlaybackStateObj.CurrentBackGroundSource.start == 0) {
          CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime =
            CurrentPlaybackStateObj.CurrentBackGroundSource.start;
          if (
            CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.duration >
            CurrentPlaybackStateObj.CurrentBackGroundSource.end - CurrentPlaybackStateObj.CurrentBackGroundSource.start
          ) {
            CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.loop = false;
            CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.addEventListener(
              'ended',
              () => {
                CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime =
                  CurrentPlaybackStateObj.CurrentBackGroundSource.start;
                CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.play();
              },
              false
            );
          }
        } else if (CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime != 0) {
          CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime = 0;
        }
        if (CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.readyState < 2) {
          this.setState({ isBuffering: true });
          if (!this.recordVideo) {
            if (CurrentPlaybackStateObj.Audio) {
              CurrentPlaybackStateObj.Audio.pause();
            }
            if (CurrentPlaybackStateObj.BackgroundMusic) {
              CurrentPlaybackStateObj.BackgroundMusic.pause();
            }
          }
        }
        if (
          CurrentPlaybackStateObj.CurrentBackGroundSource.mute !== null &&
          CurrentPlaybackStateObj.CurrentBackGroundSource.mute === false &&
          !this.isTemplatePreview
        ) {
          CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.volume = 1;
        } else {
          CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.volume = 0;
        }
        // CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.onwaiting = (event) => {
        //   this.setState({ isBuffering: true });
        // };
        // CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.onplaying   = (event) => {
        //   this.setState({ isBuffering: true });
        // };
        CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.play().then(() => {
          if (startPlay) {
            this.playScene(CurrentPlaybackStateObj, isSeek);
          } else {
            this.globalCurrentPlaybackStateObj = CurrentPlaybackStateObj;
          }
        });
      } else {
        if (startPlay) {
          this.playScene(CurrentPlaybackStateObj, isSeek);
        } else {
          this.globalCurrentPlaybackStateObj = CurrentPlaybackStateObj;
        }
      }
      //return CurrentPlaybackStateObj;
    } else {
      if (!this.recordVideo) {
        if (CurrentPlaybackStateObj.Audio) {
          CurrentPlaybackStateObj.Audio.pause();
        }
        if (CurrentPlaybackStateObj.BackgroundMusic) {
          CurrentPlaybackStateObj.BackgroundMusic.pause();
        }
        if (!this.props.singleScenePreview) {
          this.setState({ showPlay: true, gotoScenenumber: 0 });
          this.videoEnded = true;
        }
      }
      if (this.props.singleScenePreview) {
        this.handleClose();
        if (this.props.hasVideoEndedNew) {
          this.props.hasVideoEndedNew(true);
        }
      }
      // Preview Has ended. no more scenes to process
    }
  }
  playScene(CurrentPlaybackStateObj, isSeek) {
    this.setState(
      {
        showPlay: false,
        isBuffering: false,
        gotoScenenumber: -1,
      },
      async () => {
        this.isPlaying = true;
        var currentDate = Date.now();
        this.playDisplayItems(CurrentPlaybackStateObj);
        CurrentPlaybackStateObj.CurrentSceneStartTime = currentDate;
        CurrentPlaybackStateObj.CurrentSubsceneStartTime = currentDate;
        if (this.recordVideo) {
          CurrentPlaybackStateObj.PartRecordingStartTime = currentDate;
          CurrentPlaybackStateObj.PartIndex = 0;
        }
        //if (PlayAudio) {
        if (!this.recordVideo) {
          if (CurrentPlaybackStateObj.Audio && !CurrentPlaybackStateObj.Audio.isPlaying) {
            CurrentPlaybackStateObj.Audio.currentTime = CurrentPlaybackStateObj.CurrentScene.startTime;
            if (CurrentPlaybackStateObj.CurrentScene.tts === false) {
              CurrentPlaybackStateObj.Audio.volume = 0;
            } else {
              CurrentPlaybackStateObj.Audio.volume = 1;
            }
            CurrentPlaybackStateObj.Audio.play();
          }
          if (CurrentPlaybackStateObj.BackgroundMusic) {
            CurrentPlaybackStateObj.BackgroundMusic.volume = CurrentPlaybackStateObj.backgroundTrackVolume;
            if (isSeek) {
              if (CurrentPlaybackStateObj.BackgroundMusic.duration < CurrentPlaybackStateObj.CurrentScene.time) {
                CurrentPlaybackStateObj.BackgroundMusic.currentTime =
                  CurrentPlaybackStateObj.CurrentScene.startTime % CurrentPlaybackStateObj.BackgroundMusic.duration;
              } else {
                CurrentPlaybackStateObj.BackgroundMusic.currentTime = CurrentPlaybackStateObj.CurrentScene.startTime;
              }
              //CurrentPlaybackStateObj.BackgroundMusic.currentTime = 0;
            }
            if (CurrentPlaybackStateObj.CurrentScene.music === false) {
              CurrentPlaybackStateObj.BackgroundMusic.volume = 0;
            }
            if (!CurrentPlaybackStateObj.BackgroundMusic.isPlaying) {
              CurrentPlaybackStateObj.BackgroundMusic.play();
            }
          }
        }
        // }
        this.playAnimations(CurrentPlaybackStateObj);
        await this.RenderFrame(CurrentPlaybackStateObj);

        let seekbarContainerEl = document.querySelector('.video-seek-container');
        let scrollLeftCurrentScene = this.state.scrollLeftForScenes[CurrentPlaybackStateObj.CurrentSceneIndex];
        if (!seekbarContainerEl || seekbarContainerEl.scrollLeft + seekbarContainerEl.clientWidth < scrollLeftCurrentScene) {
          return;
        } else if (seekbarContainerEl.scrollLeft > scrollLeftCurrentScene) {
          // user clicks on scene on the extreme left side of scrollbar
          let scrollLeftNextScene = this.state.scrollLeftForScenes[CurrentPlaybackStateObj.CurrentSceneIndex + 1];
          if (seekbarContainerEl.scrollLeft < scrollLeftNextScene)
            seekbarContainerEl.scrollLeft -= seekbarContainerEl.scrollLeft - scrollLeftCurrentScene;
        } else {
          let scrollBoundary = seekbarContainerEl.scrollLeft + seekbarContainerEl.clientWidth;
          if (
            scrollLeftCurrentScene <= scrollBoundary &&
            scrollLeftCurrentScene + CurrentPlaybackStateObj.CurrentScene.time * SCENE_TIME_PX_MULTIPLIER > scrollBoundary
          ) {
            seekbarContainerEl.scrollLeft += seekbarContainerEl.clientWidth - (scrollBoundary - scrollLeftCurrentScene) - 10;
          }
        }
      }
    );
  }

  setSubScene(SubSceneIndex, CurrentPlaybackStateObj, startPlay = true) {
    var currentDate = Date.now();
    //Clean the stage for setting up new sub scene
    this.CleanupSubScene(CurrentPlaybackStateObj);
    var subscene = CurrentPlaybackStateObj.scenes[CurrentPlaybackStateObj.CurrentSceneIndex].sub_scenes[SubSceneIndex];
    if (subscene) {
      let SubSceneContainer = new PIXI.Container();
      // if(subscene.generateLines){
      //   var lines=this.props.GetLines(subscene.text_lines[0].text,CurrentPlaybackStateObj.CurrentScene.keywords);
      //   var textLines=[];
      //   lines.forEach(line => {
      //     var textLine = {text:line,text_animation:subscene.text_lines[0].text_animation,text_bg_animation:subscene.text_lines[0].text_bg_animation};
      //     textLines.push(textLine);
      //   });
      //   subscene.text_lines=textLines;
      // }
      if (
        this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex] &&
        this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].subscenes
      ) {
        this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].subscenes.push({
          index: SubSceneIndex,
          durationRun: 0,
          parts: [],
        });
      }
      let additionalHeightFactor = 0;
      if (subscene.font.name.includes('Poppins') || subscene.font.name.includes('NotoSans') || subscene.font.name.includes('OpenSans')) {
        //additionalHeightFactor = parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.07;
      }
      let entrySpeedArray = [];
      let exitSpeedArray = [];
      let bgSpriteFullWidthFinalY = null;
      let backgroundBoxHeight = null;
      // Added px for 0.5em default padding in <p> tag
      //let paddingX = 0.5 * parseFloat(subscene.font.size) * 1.33;
      if (subscene.displayItems && subscene.displayItems.length > 0) {
        entrySpeedArray = [];
        exitSpeedArray = [];
        for (let i = 0; i < subscene.displayItems.length; i++) {
          let dispItem = subscene.displayItems[i];
          if (dispItem.type == 'visual') {
            this.handleVisualDisplayItem(dispItem, CurrentPlaybackStateObj, SubSceneContainer);
          } else {
            for (let j = 0; j < dispItem.text_lines.length; j++) {
              let dispTextLine = dispItem.text_lines[j];
              // dispItem.font.name = dispItem.font.fontName;
              // dispItem.font.size = dispItem.font.fontSize;
              // dispItem.font.color = dispItem.font.fontColor;
              dispItem.time = subscene.time;
              if (dispItem.font.fullWidth == true && dispTextLine.text == '') {
                dispItem.text_lines[j].text = ' ';
              }
              var { textLineContainer, textPartsArray } = TextRepository.Load(CurrentPlaybackStateObj, dispItem, j);
              var Textsprite = textLineContainer;
              // if (dispItem.isCounter) {
              //   Textsprite = TextRepository.LoadText(CurrentPlaybackStateObj, dispItem, j);
              //   dispTextLine.text_animation[0].animation = 'CountDown';
              //   dispTextLine.text_animation[1].animation = 'None';
              //   //dispTextLine.text_bg_animation[0].animation = 'None';
              //   //dispTextLine.text_bg_animation[1].animation = 'None';
              // }
              this.calculateLinePosition(dispItem, Textsprite, CurrentPlaybackStateObj, j, additionalHeightFactor, dispTextLine, true);
              this.AddAnimations(
                dispTextLine,
                Textsprite,
                dispItem,
                CurrentPlaybackStateObj,
                entrySpeedArray,
                exitSpeedArray,
                j,
                backgroundBoxHeight,
                bgSpriteFullWidthFinalY,
                SubSceneContainer,
                additionalHeightFactor,
                startPlay,
                true,
                undefined,
                textPartsArray
              );
              SubSceneContainer.addChild(Textsprite);
            }
          }
        }
      }
      entrySpeedArray = [];
      exitSpeedArray = [];
      for (let i = 0; i < subscene.text_lines.length; i++) {
        var textLine = subscene.text_lines[i];
        var { textLineContainer, textPartsArray } = TextRepository.Load(CurrentPlaybackStateObj, subscene, i);
        var Textsprite = textLineContainer;
        this.calculateLinePosition(subscene, Textsprite, CurrentPlaybackStateObj, i, additionalHeightFactor, textLine);
        this.AddAnimations(
          textLine,
          Textsprite,
          subscene,
          CurrentPlaybackStateObj,
          entrySpeedArray,
          exitSpeedArray,
          i,
          backgroundBoxHeight,
          bgSpriteFullWidthFinalY,
          SubSceneContainer,
          additionalHeightFactor,
          startPlay,
          false,
          SubSceneIndex,
          textPartsArray
        );
        //End Add animations
        SubSceneContainer.addChild(Textsprite);
      }
      //Adding Sub Scene Container to Stage
      this.app.stage.addChild(SubSceneContainer);
      CurrentPlaybackStateObj.CurrentSubsceneStartTime = currentDate;
      CurrentPlaybackStateObj.CurrentSubscene = subscene;
      CurrentPlaybackStateObj.CurrentSubsceneIndex = SubSceneIndex;
      CurrentPlaybackStateObj.CurrentSubSceneContainer = SubSceneContainer;
      if (this.recordVideo) {
        CurrentPlaybackStateObj.PartRecordingStartTime = currentDate;
        CurrentPlaybackStateObj.PartIndex = 0;
      }
    }
    return CurrentPlaybackStateObj;
  }

  handleVisualDisplayItem(dispItem, CurrentPlaybackStateObj, SubSceneContainer) {
    let parsedUrl = new URL(dispItem.src);
    dispItem.src = parsedUrl.toString();
    let element = getFromCache(dispItem.id ? dispItem.src + dispItem.id : dispItem.src);
    if (!element) {
      element = TexturesMgmt.GetTexture({
        url: dispItem.id ? dispItem.src + dispItem.id : dispItem.src,
        type: dispItem.visualType,
      });
    }
    if (element) {
      if (element.valid) {
        var Sprite = new PIXI.Sprite(element.clone());
        element = Sprite;
      } else {
        element = element.clone();
      }
      let elementHeightWidthRatio = element.height / element.width;
      element.width = (parseFloat(dispItem.location.width) / 100) * CurrentPlaybackStateObj.width;
      element.height = elementHeightWidthRatio * element.width;
      if (dispItem.location.preset) {
        let position = dispItem.location.preset;
        let width = CurrentPlaybackStateObj.width;
        let height = CurrentPlaybackStateObj.height;
        if (position === 'top-left') {
          element.x = PRESET_LEFT_RIGHT_PADDING * width;
          element.y = PRESET_TOP_BOTTOM_PADDING * height;
        } else if (position === 'top-right') {
          element.x = width - element.width - PRESET_LEFT_RIGHT_PADDING * width;
          element.y = PRESET_TOP_BOTTOM_PADDING * height;
        } else if (position === 'top-center') {
          element.x = width / 2 - element.width / 2;
          element.y = PRESET_TOP_BOTTOM_PADDING * height;
        } else if (position === 'center-left') {
          element.x = PRESET_LEFT_RIGHT_PADDING * width;
          element.y = height / 2 - element.height / 2;
        } else if (position === 'center-center') {
          element.x = width / 2 - element.width / 2;
          element.y = height / 2 - element.height / 2;
        } else if (position === 'center-right') {
          element.x = width - element.width - PRESET_LEFT_RIGHT_PADDING * width;
          element.y = height / 2 - element.height / 2;
        } else if (position === 'bottom-left') {
          element.x = PRESET_LEFT_RIGHT_PADDING * width;
          element.y = height - PRESET_TOP_BOTTOM_PADDING * height - element.height;
        } else if (position === 'bottom-center') {
          element.x = width / 2 - element.width / 2;
          element.y = height - PRESET_TOP_BOTTOM_PADDING * height - element.height;
        } else if (position === 'bottom-right') {
          element.x = width - element.width - PRESET_LEFT_RIGHT_PADDING * width;
          element.y = height - PRESET_TOP_BOTTOM_PADDING * height - element.height;
        }
      } else {
        element.y = (CurrentPlaybackStateObj.height * parseFloat(dispItem.location.topCoordinate)) / 100;
        element.x = (CurrentPlaybackStateObj.width * parseFloat(dispItem.location.leftCoordinate)) / 100;
      }
      if (dispItem.location.flipHorizontal) {
        element.scale.x = -element.scale.x;
        element.x = element.x + element.width;
      }
      if (dispItem.location.flipVertical) {
        element.scale.y = -element.scale.y;
        element.y = element.y + element.height;
      }
      if (dispItem.location.rotation) {
        element.angle = dispItem.location.rotation;
      }
      if (dispItem.location.opacity) {
        element.alpha = dispItem.location.opacity;
      }
      if (dispItem.visualType === 'video' && element?.texture?.baseTexture?.resource?.source?.currentTime != undefined) {
        if (dispItem?.settings?.videoSegment?.start != undefined) {
          element.texture.baseTexture.resource.source.currentTime = dispItem?.settings?.videoSegment?.start;
          element.texture.baseTexture.resource.source.load();
        } else {
          element.texture.baseTexture.resource.source.currentTime = 0;
        }
        element.texture.baseTexture.resource.source.pause();
        if (dispItem?.settings?.loopVideo) {
          element.texture.baseTexture.resource.source.loop = true;
        } else {
          element.texture.baseTexture.resource.source.loop = false;
        }
        if (dispItem?.settings?.videoSegment?.start != undefined) {
          element.texture.baseTexture.resource.source.currentTime = dispItem?.settings?.videoSegment?.start;
          element.texture.baseTexture.resource.source.load();
          if (dispItem?.settings?.loopVideo) {
            element.texture.baseTexture.resource.source.addEventListener(
              'ended',
              () => {
                element.texture.baseTexture.resource.source.currentTime = dispItem?.settings?.videoSegment?.start;
                element.texture.baseTexture.resource.source.play();
              },
              false
            );
          }
          if (dispItem?.settings?.videoSegment?.start != undefined && dispItem?.settings?.videoSegment?.end != undefined) {
            element.texture.baseTexture.resource.source.loop = false;
            element.texture.baseTexture.resource.source.addEventListener(
              'timeupdate',
              () => {
                if (element?.texture?.baseTexture?.resource?.source?.currentTime >= dispItem?.settings?.videoSegment?.end) {
                  if (dispItem?.settings?.loopVideo) {
                    element.texture.baseTexture.resource.source.currentTime = dispItem?.settings?.videoSegment?.start;
                    element.texture.baseTexture.resource.source.play();
                  } else {
                    element.texture.baseTexture.resource.source.pause();
                  }
                }
              },
              false
            );
          }
        }
        if (dispItem?.settings?.muteClipAudio) {
          element.texture.baseTexture.resource.source.volume = 0;
        } else {
          element.texture.baseTexture.resource.source.volume = 1;
        }
        CurrentPlaybackStateObj.displayItemVideos.push(element);
      }
      SubSceneContainer.addChild(element);
      if (dispItem?.settings?.colorOverlay && !dispItem?.settings?.colorOverlay?.hide) {
        let overlay = this.GenerateBackgroundGraphic(dispItem?.settings?.colorOverlay.bgColor, element.width, element.height);
        overlay.alpha = dispItem?.settings?.colorOverlay.opacity;
        overlay.x = element.x;
        overlay.y = element.y;
        if (dispItem.location.flipHorizontal) {
          overlay.scale.x = -overlay.scale.x;
          //overlay.x = overlay.x + overlay.width;
        }
        if (dispItem.location.flipVertical) {
          overlay.scale.y = -overlay.scale.y;
          //overlay.y = overlay.y - overlay.height;
        }
        if (dispItem.location.rotation) {
          overlay.angle = dispItem.location.rotation;
        }
        SubSceneContainer.addChild(overlay);
      }
    }
  }

  removeHTML(str) {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || '';
  }

  AddAnimations(
    textLine,
    Textsprite,
    subscene,
    CurrentPlaybackStateObj,
    entrySpeedArray,
    exitSpeedArray,
    i,
    backgroundBoxHeight,
    bgSpriteFullWidthFinalY,
    SubSceneContainer,
    additionalHeightFactor,
    startPlay,
    isDispItem,
    SubSceneIndex,
    textPartsArray
  ) {
    let textLength = 0;
    if (textLine.text) {
      textLength = textLine.text.replaceAll('<strong>', '').replaceAll('</strong>', '').length;
    }
    let originalTextSpriteY = Textsprite.y;
    let addAnimation = true;
    let addOnlyEntryAnimation = false;
    ////////////////////////// Animation time calculations
    let entrySpeed = 0;
    let exitSpeed = 0;
    let totalEntryTime = 0.1;
    let totalExitTime = 0.1;
    let isTypewriterAnimation = false;
    if (
      textLine.text_animation &&
      textLine.text_animation.length > 0 &&
      textLine.text_animation[0].animation !== '' &&
      (textLine.text_animation[0].source === 'templates' || textLine.text_animation[0].name)
    ) {
      let numberofLines = subscene.text_lines.length;
      totalEntryTime = 0.1;
      totalExitTime = 0.1;
      let startAnimation = textLine.text_animation.filter((x) => x.type == 'start' || (x.type == 'entry' && x.animation != 'none'));
      let endAnimation = textLine.text_animation.filter((x) => x.type == 'end' || (x.type == 'exit' && x.animation != 'none'));
      if (startAnimation[0] && startAnimation[0].speed && startAnimation[0].speed >= 0) {
        entrySpeed = startAnimation[0].speed;
      }
      if (endAnimation[0] && endAnimation[0].speed && endAnimation[0].speed >= 0) {
        exitSpeed = endAnimation[0].speed;
      }
      totalEntryTime = numberofLines * entrySpeed;
      totalExitTime = numberofLines * exitSpeed;
      if (
        textLine.text_bg_animation &&
        !isDispItem &&
        (textLine.text_bg_animation?.filter(x => x.animation == 'typewriter-reveal')?.length > 0 ||
          textLine.text_bg_animation?.filter(x => x.name == 'Typewriter')?.length > 0)
      ) {
        isTypewriterAnimation = true;
        if (exitSpeed == 0) {
          totalEntryTime = subscene.time;
        } else {
          totalExitTime = numberofLines * exitSpeed + 1;
        }
      }
      
      let totalEntryExitTime = totalEntryTime + totalExitTime;
      let ratio = 1;

      if (totalEntryExitTime > subscene.time) {
        if (isTypewriterAnimation) {
          addAnimation = true;
          addOnlyEntryAnimation = false;
          if (exitSpeed > 0) {
            totalEntryExitTime = totalEntryExitTime + 1;
          }
          ratio = subscene.time / totalEntryExitTime;
          totalEntryTime = ratio * totalEntryTime;
          totalExitTime = ratio * totalExitTime;
          entrySpeed = totalEntryTime / numberofLines;
          exitSpeed = totalExitTime / numberofLines;
        } else {
          addAnimation = false;
          //return { backgroundBoxHeight, bgSpriteFullWidthFinalY };
          if (totalEntryTime < subscene.time) {
            addAnimation = true;
            addOnlyEntryAnimation = true;
            totalExitTime = 0;
            entrySpeed = totalEntryTime / numberofLines;
            exitSpeed = 0;
          }
        }
      }
      let totalChars = 0;
      if (CurrentPlaybackStateObj.scenes[CurrentPlaybackStateObj.CurrentSceneIndex]?.subtitles?.[SubSceneIndex]?.text?.length > 0) {
        totalChars = CurrentPlaybackStateObj.scenes[CurrentPlaybackStateObj.CurrentSceneIndex].subtitles[SubSceneIndex].text.length;
      } else if (isDispItem && subscene?.text_lines?.length > 0) {
        let dispItemText = '';
        for (let u = 0; u < i; u++) {
          dispItemText = dispItemText + ' ' + subscene?.text_lines[u].text;
        }
        totalChars = dispItemText.length;
      }
      if (
        totalChars &&
        textLine.text_bg_animation &&
        !isDispItem &&
        (textLine.text_bg_animation?.filter(x => x.animation == 'typewriter-reveal')?.length > 0 ||
          textLine.text_bg_animation?.filter((x) => x.name == 'Typewriter')?.length > 0)
      ) {
        // let totalChars =
        //   CurrentPlaybackStateObj.scenes[CurrentPlaybackStateObj.CurrentSceneIndex].subtitles[SubSceneIndex].text
        //     .length;
        entrySpeed = (totalEntryTime * this.removeHTML(textLine.text).replaceAll('<strong>', '').replaceAll('</strong>', '').length) / totalChars;
        entrySpeedArray.push(entrySpeed);
        exitSpeed = (totalExitTime * this.removeHTML(textLine.text).replaceAll('<strong>', '').replaceAll('</strong>', '').length) / totalChars;
        exitSpeedArray.push(exitSpeed);
      } 
      else {
        if (isDispItem) {
          entrySpeedArray.push(entrySpeed);
          exitSpeedArray.push(exitSpeed);
        }
      }
    }
    /////////////////////////
    if (
      ((subscene.font.backcolor && subscene.font.backcolor !== 'none') ||
        (subscene.font.backcolor_fullwidth && subscene.font.backcolor_fullwidth !== 'none')) &&
      textLine.text
    ) {
      if (i == 0 && subscene.font.fullWidth == true) {
        var TextBackgroundSprite = this.GenerateBackgroundGraphic(
          subscene.font.backcolor_fullwidth ? subscene.font.backcolor_fullwidth : subscene.font.backcolor,
          CurrentPlaybackStateObj.width,
          subscene.fullWidthBG.height
        );
        TextBackgroundSprite.x = 0;
        TextBackgroundSprite.y = subscene.fullWidthBG.y;
        SubSceneContainer.addChild(TextBackgroundSprite);
      }
      // if (i == 0 && subscene.font.fullWidth == true) {
      //   let addedHeight = 22;
      //   if (CurrentPlaybackStateObj.currentScaleY < 0.2) {
      //     addedHeight = 0;
      //   }
      //   backgroundBoxHeight = CurrentPlaybackStateObj.height - originalTextSpriteY + addedHeight;
      //   bgSpriteFullWidthFinalY = CurrentPlaybackStateObj.height - backgroundBoxHeight;
      //   if (CurrentPlaybackStateObj.height / 3 > backgroundBoxHeight) {
      //     backgroundBoxHeight = CurrentPlaybackStateObj.height / 3;
      //     bgSpriteFinalY = CurrentPlaybackStateObj.height - backgroundBoxHeight;
      //     // Textsprite.y =
      //     //   bgSpriteFinalY + 16 + i * (CurrentPlaybackStateObj.height - 32 / subscene.text_lines.length) +;
      //   }
      //   var TextBackgroundSprite = this.GenerateBackgroundGraphic(
      //     subscene.font.backcolor_fullwidth ? subscene.font.backcolor_fullwidth : subscene.font.backcolor,
      //     CurrentPlaybackStateObj.width,
      //     backgroundBoxHeight
      //   );
      //   if (subscene.font.fullWidth == true) {
      //     Textsprite.y = bgSpriteFinalY + 16 * CurrentPlaybackStateObj.currentScaleY;
      //   }
      //   TextBackgroundSprite.x = 0;
      //   TextBackgroundSprite.y = bgSpriteFullWidthFinalY;
      //   SubSceneContainer.addChild(TextBackgroundSprite);
      // }
      // if (subscene.font.fullWidth == true && this.props.transcribePreview) {
      //   Textsprite.x = Textsprite.x + (0.25 * (parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY));
      // }
      // if (subscene.font.fullWidth == true && bgSpriteFullWidthFinalY) {
      //   // if (
      //   //   CurrentPlaybackStateObj.height / 3 >
      //   //   CurrentPlaybackStateObj.height - Textsprite.y - 32 * CurrentPlaybackStateObj.currentScaleY
      //   // ) {
      //   //   let numberofLines = subscene.text_lines.length;
      //   //   let totaltextHeight =
      //   //     numberofLines *
      //   //     (subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY +
      //   //       additionalHeightFactor +
      //   //       (subscene.font.line_spacing - 1) *
      //   //         (parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY));
      //   //   let buffer = backgroundBoxHeight - totaltextHeight;
      //   //   Textsprite.y =
      //   //     bgSpriteFinalY +
      //   //     buffer / 2 +
      //   //     i *
      //   //       (subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY +
      //   //         additionalHeightFactor +
      //   //         (subscene.font.line_spacing - 1) *
      //   //           (parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY));
      //   // } else {
      //   let paddingFactor = 20;
      //   if (this.props.transcribePreview) {
      //     paddingFactor = 22;
      //   }
      //   if (CurrentPlaybackStateObj.currentScaleY < 0.2) {
      //     paddingFactor = 5;
      //   }
      //   Textsprite.y =
      //     bgSpriteFullWidthFinalY +
      //     paddingFactor +
      //     i *
      //       (subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY +
      //         additionalHeightFactor +
      //         5 +
      //         (subscene.font.line_spacing - 1) *
      //           (parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY));
      //   //}
      // }
      //if (true) {
      let backHeight = 0;
      if (subscene.font.line_height) {
        backHeight =
          subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY +
          parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.15;
      } else {
        backHeight =
          Textsprite.height - parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.75 + additionalHeightFactor;
        if (subscene.font.line_height && subscene.font.line_height > 0) {
          let backHeightFromLineHeight =
            subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY +
            parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.15 +
            additionalHeightFactor;
          backHeight = backHeightFromLineHeight > backHeight ? backHeightFromLineHeight : backHeight;
        }
      }
      let addedWidth = 0;
      if (CurrentPlaybackStateObj.isTemplateGridPreview) {
        addedWidth = 5;
      }
      var TextBackgroundSprite = this.GenerateBackgroundGraphic(subscene.font.backcolor, Textsprite.width + addedWidth, backHeight);
      var TextBackgroundMask = this.GenerateBackgroundGraphic('rgba(0,0,0,1)', Textsprite.width + addedWidth, backHeight, true);
      //var Textsprite = new PIXI.Sprite(textElement);
      //TextBackgroundSprite.alpha = 0.6;
      //Add animations- need to move to a seperate class or func
      //let backgroundHeight = subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY;
      let backgroundHeight = TextBackgroundSprite.height;
      let bgSpriteFinalX = Textsprite.x - parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.4;
      let bgSpriteFinalY = Textsprite.y - parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.08;
      if (subscene.font.name.includes('Rokkitt') && CurrentPlaybackStateObj.currentScaleY > 0.25) {
        bgSpriteFinalY = bgSpriteFinalY - 0.1 * Textsprite.height;
      }
      if (this.props.isTemplateGridPreview) {
        //bgSpriteFinalY = bgSpriteFinalY + 0.025 * bgSpriteFinalY;
      }
      if (this.props.transcribePreview) {
        bgSpriteFinalY = 0.99 * bgSpriteFinalY;
        bgSpriteFinalX = 0.99 * bgSpriteFinalX;
      }
      TextBackgroundSprite.x = bgSpriteFinalX;
      TextBackgroundSprite.y = bgSpriteFinalY;
      TextBackgroundMask.x = bgSpriteFinalX;
      TextBackgroundMask.y = bgSpriteFinalY;
      //Textsprite.mask=TextBackgroundMask;
      if (!subscene.font.fullWidth) {
        SubSceneContainer.addChild(TextBackgroundSprite);
      }

      //SubSceneContainer.addChild(TextBackgroundMask);
      //textLine.text_bg_animation[0].animation="fade-in-slide-up";
      //textLine.text_bg_animation[0].speed = 2;
      let textBackgroundSpriteHeight = TextBackgroundSprite.height;
      let textBackgroundSpriteWidth = TextBackgroundSprite.width;
      if (
        textLine.text_bg_animation &&
        textLine.text_bg_animation.length > 0 &&
        textLine.text_bg_animation[0].animation !== '' &&
        startPlay &&
        addAnimation
      ) {
        for (let t = 0; t < textLine.text_bg_animation.length; t++) {
          if (textLine?.text_bg_animation?.[t]?.name) {
            let animationObj = textLine.text_bg_animation[t];
            const ComponentToRender = Components[animationObj.name.replace(' ', '')];
            var speed = entrySpeed;
            var delayValue = 0;
            if (animationObj.type === 'exit') {
              speed = exitSpeed;
              if (animationObj.name == 'Typewriter' || exitSpeedArray.length > 0) {
                delayValue = subscene.time - totalExitTime;
                if (exitSpeedArray?.length > 0) {
                  for (let u = 0; u < i; u++) {
                    delayValue = delayValue + exitSpeedArray[u];
                  }
                }
              } else {
                if (
                  animationObj.writingStyle &&
                  animationObj.writingStyle != 'paragraph' &&
                  subscene.time - (subscene.text_lines.length - i) * speed >= 0
                ) {
                  delayValue = subscene.time - (subscene.text_lines.length - i) * speed;
                } else {
                  delayValue = subscene.time - speed;
                }
              }
            } else {
              speed = entrySpeed;
              if (entrySpeedArray.length > 0) {
                if (entrySpeedArray?.length > 0) {
                  for (let u = 0; u < i; u++) {
                    delayValue = delayValue + entrySpeedArray[u];
                  }
                }
              } else if (animationObj.writingStyle != 'paragraph') {
                delayValue = (i * speed) / 3;
              }
            }
            if (ComponentToRender) {
              if (speed > 0) {
                var textBackgroundAnimation = ComponentToRender.Animate(TextBackgroundSprite, {
                  speed: speed,
                  canvasHeight: CurrentPlaybackStateObj.height,
                  canvasWidth: CurrentPlaybackStateObj.width,
                  index: i,
                  totalLines: subscene.text_lines.length,
                  isBackground: true,
                  delayValue: delayValue,
                  textLength: textLength,
                  SpriteFinalX: bgSpriteFinalX,
                  SpriteFinalY: bgSpriteFinalY,
                  entrySpeedArray: entrySpeedArray,
                  elementToAnimate: TextBackgroundSprite,
                  type: animationObj.type,
                  direction: animationObj.direction,
                  textPartsArray,
                  textBackgroundSpriteHeight: textBackgroundSpriteHeight,
                  textBackgroundSpriteWidth: textBackgroundSpriteWidth,
                  fullWidth: subscene.font.fullWidth,
                });
                var textBackgroundMaskAnimation = ComponentToRender.Animate(TextBackgroundMask, {
                  speed: speed,
                  canvasHeight: CurrentPlaybackStateObj.height,
                  canvasWidth: CurrentPlaybackStateObj.width,
                  index: i,
                  totalLines: subscene.text_lines.length,
                  isBackground: true,
                  isMask: true,
                  Textsprite: Textsprite,
                  SubSceneContainer: SubSceneContainer,
                  delayValue: delayValue,
                  textLength: textLength,
                  SpriteFinalX: bgSpriteFinalX,
                  SpriteFinalY: bgSpriteFinalY,
                  entrySpeedArray: entrySpeedArray,
                  elementToAnimate: TextBackgroundMask,
                  type: animationObj.type,
                  direction: animationObj.direction,
                  TextBackgroundSprite: TextBackgroundSprite,
                  textPartsArray,
                  textBackgroundSpriteHeight: textBackgroundSpriteHeight,
                  textBackgroundSpriteWidth: textBackgroundSpriteWidth,
                  fullWidth: subscene.font.fullWidth,
                });
                if (textBackgroundAnimation) {
                  CurrentPlaybackStateObj.TextAnimations.push(textBackgroundAnimation);
                }
                if (textBackgroundMaskAnimation) {
                  CurrentPlaybackStateObj.TextAnimations.push(textBackgroundMaskAnimation);
                }
              }
            }
          } else {
            const ComponentToRender = Components[textLine.text_bg_animation[t].animation];
            if (ComponentToRender) {
              let isTemplate = false;
              var speed = textLine.text_bg_animation[t].speed;
              if (textLine.text_bg_animation[t].source === 'templates') {
                isTemplate = true;
                speed = entrySpeed;
                var delayValue = 0;
                if (textLine.text_bg_animation && textLine.text_bg_animation[t].type === 'end') {
                  speed = exitSpeed;
                  if (subscene.time - (subscene.text_lines.length - i) * speed > 0) {
                    delayValue = subscene.time - (subscene.text_lines.length - i) * speed;
                  } else {
                    delayValue = 0.1;
                  }
                }
              } else {
                if (textLine.text_bg_animation[t].speed + 0.2 > subscene.time) {
                  speed = subscene.time / 2;
                  if (textLine.text_animation && textLine.text_animation[t] && textLine.text_animation[t].speed) {
                    speed = speed - (textLine.text_animation[t].speed - textLine.text_bg_animation[t].speed);
                  }
                }
              }
              if (speed > 0) {
                var textBackgroundAnimation = ComponentToRender.Animate(TextBackgroundSprite, {
                  speed: speed,
                  canvasHeight: CurrentPlaybackStateObj.height,
                  canvasWidth: CurrentPlaybackStateObj.width,
                  index: i,
                  totalLines: subscene.text_lines.length,
                  isBackground: true,
                  delayValue: delayValue,
                  textLength: textLength,
                  isTemplate: isTemplate,
                  SpriteFinalX: bgSpriteFinalX,
                  SpriteFinalY: bgSpriteFinalY,
                  entrySpeedArray: entrySpeedArray,
                });
                var textBackgroundMaskAnimation = ComponentToRender.Animate(TextBackgroundMask, {
                  speed: speed,
                  canvasHeight: CurrentPlaybackStateObj.height,
                  canvasWidth: CurrentPlaybackStateObj.width,
                  index: i,
                  totalLines: subscene.text_lines.length,
                  isBackground: true,
                  isMask: true,
                  Textsprite: Textsprite,
                  SubSceneContainer: SubSceneContainer,
                  delayValue: delayValue,
                  textLength: textLength,
                  isTemplate: isTemplate,
                  SpriteFinalX: bgSpriteFinalX,
                  SpriteFinalY: bgSpriteFinalY,
                  entrySpeedArray: entrySpeedArray,
                });

                if (textBackgroundAnimation) {
                  CurrentPlaybackStateObj.TextAnimations.push(textBackgroundAnimation);
                }
                if (textBackgroundMaskAnimation) {
                  CurrentPlaybackStateObj.TextAnimations.push(textBackgroundMaskAnimation);
                }
              }
              //Textsprite.mask = TextBackgroundSprite;
            }
          }
        }
      }
      //}
    }
    //textLine.text_animation[0].animation = "fade-in-slide-up";
    //textLine.text_animation[0].speed = 2;
    let textSpriteFinalX = Textsprite.x;
    let textSpriteFinalY = Textsprite.y;
    if (textLine.text_animation && textLine.text_animation.length > 0 && textLine.text_animation[0].animation !== '' && startPlay && addAnimation) {
      for (let t = 0; t < textLine.text_animation.length; t++) {
        if (textLine?.text_animation?.[t]?.name) {
          let animationObj = textLine.text_animation[t];
          const ComponentToRender = Components[animationObj.name.replace(' ', '')];
          var speed = entrySpeed;
          var delayValue = 0;
          if (animationObj.type === 'exit') {
            speed = exitSpeed;
            if (animationObj.name == 'Typewriter' || exitSpeedArray.length > 0) {
              delayValue = subscene.time - totalExitTime;
              if (exitSpeedArray?.length > 0) {
                for (let u = 0; u < i; u++) {
                  delayValue = delayValue + exitSpeedArray[u];
                }
              }
            } else {
              if (
                animationObj.writingStyle &&
                animationObj.writingStyle != 'paragraph' &&
                subscene.time - (subscene.text_lines.length - i) * speed >= 0
              ) {
                delayValue = subscene.time - (subscene.text_lines.length - i) * speed;
              } else {
                delayValue = subscene.time - speed;
              }
            }
          } else {
            speed = entrySpeed;
            if (entrySpeedArray.length > 0) {
              if (entrySpeedArray?.length > 0) {
                for (let u = 0; u < i; u++) {
                  delayValue = delayValue + entrySpeedArray[u];
                }
              }
            } else if (animationObj.writingStyle != 'paragraph') {
              delayValue = (i * speed) / 3;
            }
          }
          if (ComponentToRender) {
            let elementToAnimate = Textsprite;
            if (animationObj.writingStyle == 'character' || animationObj.writingStyle == 'word') {
              elementToAnimate = textPartsArray;
            }
            if (speed > 0) {
              var textAnimation = ComponentToRender.Animate(Textsprite, {
                speed: speed,
                canvasHeight: CurrentPlaybackStateObj.height,
                canvasWidth: CurrentPlaybackStateObj.width,
                index: i,
                totalLines: subscene.text_lines.length,
                delayValue: delayValue,
                textLength: textLength,
                SpriteFinalX: textSpriteFinalX,
                SpriteFinalY: textSpriteFinalY,
                elementToAnimate: elementToAnimate,
                type: animationObj.type,
                direction: animationObj.direction,
              });
              if (textAnimation) {
                CurrentPlaybackStateObj.TextAnimations.push(textAnimation);
              }
            }
          }
        } else {
          const ComponentToRender = Components[textLine.text_animation[t].animation];
          if (ComponentToRender) {
            let isTemplate = false;
            var speed = textLine.text_animation[t].speed;
            if (textLine.text_animation[t].source === 'templates') {
              isTemplate = true;
              speed = entrySpeed;
              var delayValue = 0;
              if (textLine.text_animation[t].type === 'end') {
                speed = exitSpeed;
                if (subscene.time - (subscene.text_lines.length - i) * speed > 0) {
                  delayValue = subscene.time - (subscene.text_lines.length - i) * speed;
                } else {
                  delayValue = 0.1;
                }
              }
            } else {
              if (textLine.text_animation[t].speed + 0.2 > subscene.time) {
                speed = subscene.time / 2;
              }
            }
            if (speed > 0) {
              var textAnimation = ComponentToRender.Animate(Textsprite, {
                speed: speed,
                canvasHeight: CurrentPlaybackStateObj.height,
                canvasWidth: CurrentPlaybackStateObj.width,
                index: i,
                totalLines: subscene.text_lines.length,
                delayValue: delayValue,
                textLength: textLength,
                isTemplate: isTemplate,
                SpriteFinalX: textSpriteFinalX,
                SpriteFinalY: textSpriteFinalY,
              });
              if (textAnimation) {
                CurrentPlaybackStateObj.TextAnimations.push(textAnimation);
              }
            }
          }
        }
      }
      // const ComponentToRender2 = Components["fade-out-slide-up"];
      // if (ComponentToRender2) {
      //   var speed = textLine.text_animation[0].speed;
      //   if (textLine.text_animation[0].speed + 0.2 > subscene.time) {
      //     speed = subscene.time / 2;
      //   }
      //   var textAnimation = ComponentToRender2.Animate(Textsprite, { speed: speed, canvasHeight: CurrentPlaybackStateObj.height, canvasWidth: CurrentPlaybackStateObj.width, index: i, totalLines: subscene.text_lines.length });
      //   if(textAnimation){
      //   CurrentPlaybackStateObj.TextAnimations.push(textAnimation);
      //   }
      // }
    }
    return { backgroundBoxHeight, bgSpriteFullWidthFinalY };
  }

  calculateLinePosition(subscene, Textsprite, CurrentPlaybackStateObj, i, additionalHeightFactor, textLine, isDispItem) {
    if (subscene.location.start_x !== undefined && subscene.location.start_x !== '') {
      Textsprite.x = subscene.location.start_x * CurrentPlaybackStateObj.currentScaleX;
    } else if (subscene.location.end_x !== undefined && subscene.location.end_x !== '') {
      Textsprite.x = subscene.location.end_x * CurrentPlaybackStateObj.currentScaleX - Textsprite.width;
      Textsprite.x = Textsprite.x + parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.6;
    } else if (subscene.location.center_x !== undefined && subscene.location.center_x !== '') {
      Textsprite.x = subscene.location.center_x * CurrentPlaybackStateObj.currentScaleX - Textsprite.width / 2;
      //Textsprite.x = Textsprite.x + Textsprite.width * 0.018;
      Textsprite.x = Textsprite.x + parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.5;
    } else {
      Textsprite.x = CurrentPlaybackStateObj.width / 2 - Textsprite.width / 2;
    }
    if (subscene.font.fullWidth) {
      Textsprite.x = Textsprite.x == 0 ? 8 + parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.25 : Textsprite.x;
    }
    let isTopY = false;
    if (subscene.location.start_y !== undefined && subscene.location.start_y !== '') {
      //if (subscene.font.line_height) {
      // added padding at the top
      if (
        subscene.location.start_y <= 16 + parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.1 ||
        subscene.location.start_y == 0
      ) {
        isTopY = true;
      }
      if (subscene.font.line_height) {
        let backHeightFromLineHeight =
          subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY +
          parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.19;
        Textsprite.y = subscene.location.start_y * CurrentPlaybackStateObj.currentScaleY + i * backHeightFromLineHeight;
      } else {
        Textsprite.y =
          subscene.location.start_y * CurrentPlaybackStateObj.currentScaleY +
          parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.15 +
          i *
            (Textsprite.height -
              parseFloat(subscene.font.size) *
                1.33 *
                CurrentPlaybackStateObj.currentScaleY *
                (CurrentPlaybackStateObj.currentScaleY < 0.4 && subscene.font.size < 40 ? 0.6 : 0.2));
        //}
        if (CurrentPlaybackStateObj.width < CurrentPlaybackStateObj.height && CurrentPlaybackStateObj.currentScaleY < 0.4) {
          if (subscene.font.size > 40 && subscene.font.size < 80 && CurrentPlaybackStateObj.currentScaleY < 0.2) {
            Textsprite.y = Textsprite.y - i * (parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.5);
          }
        }
      }
      if (!textLine.text) {
        Textsprite.y = Textsprite.y - 10;
      }
    } else if (subscene.location.end_y !== undefined && subscene.location.end_y !== '') {
      Textsprite.y =
        subscene.location.end_y * CurrentPlaybackStateObj.currentScaleY -
        (subscene.text_lines.length - i) * (subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY);
    } else {
      Textsprite.y = CurrentPlaybackStateObj.height / 2 - Textsprite.height / 2;
    }

    if (this.props.isTemplateGridPreview && subscene.font.fullWidth && subscene.location.preset == 'full-width-center') {
      Textsprite.y = Textsprite.y + 18;
    }
    if (subscene.font.fullWidth) {
      subscene.fullWidthBG = {};
      let textLineHeight = Textsprite.height;
      let fontSizePx = parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY;
      let marginTopBottom = 16 + fontSizePx * 0.15;

      let textBoxHeight =
        parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.15 +
        subscene.text_lines.length * (Textsprite.height - parseFloat(subscene.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY * 0.2);
      if (subscene.location.preset == 'full-width-top' || isTopY) {
        Textsprite.y = i * (Textsprite.height - fontSizePx * 0.2) + marginTopBottom;
        subscene.fullWidthBG.y = 0;
        subscene.fullWidthBG.height = 2 * marginTopBottom + (Textsprite.height - textLineHeight * 0.25) * subscene.text_lines.length;
      } else if (subscene.location.preset == 'full-width-bottom') {
        Textsprite.y =
          CurrentPlaybackStateObj.height - marginTopBottom - (subscene.text_lines.length - i) * (Textsprite.height - textLineHeight * 0.25);
        subscene.fullWidthBG.y = i == 0 ? Textsprite.y - marginTopBottom : 0;
        subscene.fullWidthBG.height = CurrentPlaybackStateObj.height - subscene.fullWidthBG.y;
      } else if (subscene.location.preset == 'full-width-center') {
        subscene.fullWidthBG.y = i == 0 ? Textsprite.y - marginTopBottom : 0;
        subscene.fullWidthBG.height =
          2 * marginTopBottom + (Textsprite.height - textLineHeight * 0.25 + 0.2 * marginTopBottom) * subscene.text_lines.length;
      } else {
        Textsprite.y = Textsprite.y + marginTopBottom + textLineHeight * 0.1;
        subscene.fullWidthBG.y = i == 0 ? Textsprite.y - marginTopBottom : 0;
        subscene.fullWidthBG.height =
          2 * marginTopBottom + (Textsprite.height - textLineHeight * 0.25 + 0.2 * marginTopBottom) * subscene.text_lines.length;
        if (this.props.isTemplateGridPreview) {
          Textsprite.y = Textsprite.y - 15;
          subscene.fullWidthBG.y = i == 0 ? Textsprite.y - 16 : 0;
          subscene.fullWidthBG.height = textBoxHeight + 20 + textBoxHeight * 0.15;
        }
      }
    }
  }

  calculatePosition(paddingX, dispItem, Textsprite, CurrentPlaybackStateObj, i, additionalHeightFactor, textLine) {
    paddingX = 0.5 * parseFloat(dispItem.font.size) * 1.33;
    if (dispItem.location.center_x !== undefined && dispItem.location.center_x !== '') {
      Textsprite.x = dispItem.location.center_x * CurrentPlaybackStateObj.currentScaleX - Textsprite.width / 2;
    }
    if (dispItem.location.start_y !== undefined && dispItem.location.start_y !== '') {
      // if (subscene.font.line_height && false) {
      //   Textsprite.y = (subscene.location.start_y * CurrentPlaybackStateObj.currentScaleY) + (i * ((subscene.font.line_height * CurrentPlaybackStateObj.currentScaleY)));
      // }
      // else {
      // if (subscene.font.line_spacing === 1) {
      //   Textsprite.y = (subscene.location.start_y * CurrentPlaybackStateObj.currentScaleY) + (i * (Textsprite.height + (subscene.font.line_spacing) + 1));
      // }
      // else {
      if (dispItem.font.line_height) {
        // added padding at the top
        Textsprite.y =
          (dispItem.location.start_y + DEFAULT_LINE_PADDING_FACTOR * parseFloat(dispItem.font.size) * 1.33) * CurrentPlaybackStateObj.currentScaleY +
          i *
            (dispItem.font.line_height * CurrentPlaybackStateObj.currentScaleY +
              additionalHeightFactor +
              (dispItem.font.line_spacing - 1) * (parseFloat(dispItem.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY));
        Textsprite.y = Textsprite.y + dispItem.font.line_height * CurrentPlaybackStateObj.currentScaleY - Textsprite.height;
      } else {
        Textsprite.y =
          dispItem.location.start_y * CurrentPlaybackStateObj.currentScaleY +
          i *
            (Textsprite.height +
              (dispItem.font.line_spacing - 1) * (parseFloat(dispItem.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY) +
              2);
        Textsprite.y =
          Textsprite.y +
          dispItem.font.line_height * CurrentPlaybackStateObj.currentScaleY -
          Textsprite.height +
          (DEFAULT_LINE_HEIGHT_FACTOR - 2 * DEFAULT_LINE_PADDING_FACTOR) *
            (parseFloat(dispItem.font.size) * 1.33 * CurrentPlaybackStateObj.currentScaleY);
      }
      if (!textLine.text) {
        Textsprite.y = Textsprite.y - 10;
      }
      //}
      //}
    }
    return paddingX;
  }

  setNextBackground(CurrentPlaybackStateObj) {
    if (
      CurrentPlaybackStateObj.CurrentBackGroundSource &&
      CurrentPlaybackStateObj.CurrentBackGroundSource.type === 'video' &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture
    ) {
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.pause();
    }
    CurrentPlaybackStateObj.CurrentBackgroundSprite.visible = false;

    CurrentPlaybackStateObj.CurrentBackgroundIndex = CurrentPlaybackStateObj.CurrentBackgroundIndex + 1;
    CurrentPlaybackStateObj.CurrentBackGroundSource = CurrentPlaybackStateObj.sceneBackgroundSources[CurrentPlaybackStateObj.CurrentBackgroundIndex];
    CurrentPlaybackStateObj.CurrentBackgroundTexture =
      CurrentPlaybackStateObj.sceneBackgroundTextures[CurrentPlaybackStateObj.CurrentBackgroundIndex];
    CurrentPlaybackStateObj.CurrentBackgroundSprite = CurrentPlaybackStateObj.sceneBackgroundSprites[CurrentPlaybackStateObj.CurrentBackgroundIndex];
    CurrentPlaybackStateObj.CurrentBackgroundSprite.visible = true;
    if (CurrentPlaybackStateObj.CurrentBackGroundSource.start) {
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime =
        CurrentPlaybackStateObj.CurrentBackGroundSource.start;
    } else if (CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime != 0) {
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime = 0;
    }
    if (
      CurrentPlaybackStateObj.CurrentBackGroundSource &&
      CurrentPlaybackStateObj.CurrentBackGroundSource.type === 'video' &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture
    ) {
      if (
        CurrentPlaybackStateObj.CurrentBackGroundSource.mute !== null &&
        CurrentPlaybackStateObj.CurrentBackGroundSource.mute === false &&
        !this.isTemplatePreview
      ) {
        CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.volume = 1;
      } else {
        CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.volume = 0;
      }
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.play().then(() => {
        this.setState({
          showPlay: false,
          isBuffering: false,
          gotoScenenumber: -1,
        });
      });
    }
    return CurrentPlaybackStateObj;
  }
  RenderFrame = async (CurrentPlaybackStateObj) => {
    if (this.recordVideo && this.animationRecordingEnabled) {
      if (!this.props.webmrecording) {
        if (this.frameRecordingStartTime !== null) {
          let timeDifferenceMilliSeconds = Date.now() - this.frameRecordingStartTime;
          if (timeDifferenceMilliSeconds < FRAME_GAP_MS) {
            requestAnimationFrame(async () => await this.RenderFrame(CurrentPlaybackStateObj));
            return;
          } else {
            this.frameRecordingStartTime = Date.now();
          }
        } else {
          this.frameRecordingStartTime = Date.now();
        }
      }
    }

    if (CurrentPlaybackStateObj != null) {
      this.globalCurrentPlaybackStateObj = CurrentPlaybackStateObj;
      if (this.recordVideo) {
        window.recordingCurrentFrameNumber = CurrentPlaybackStateObj.CurrentFrameNumber;
        console.log(`RENDER_FRAME:${CurrentPlaybackStateObj.CurrentFrameNumber}, SUB_SCENE - ${CurrentPlaybackStateObj.CurrentSubsceneIndex || 0}`);
      }
      var currentDate = Date.now();
      if (this.state.showPreview && this.isPlaying) {
        CurrentPlaybackStateObj.ElapsedTime = currentDate - CurrentPlaybackStateObj.CurrentSceneStartTime;
        var progress = ((CurrentPlaybackStateObj.CurrentScene.startTime + CurrentPlaybackStateObj.ElapsedTime / 1000) / this.state.totalTime) * 100;
        this.setState({
          progress: progress + '%',
          timeDone: CurrentPlaybackStateObj.CurrentScene.startTime + CurrentPlaybackStateObj.ElapsedTime / 1000,
        });
        CurrentPlaybackStateObj.CurrentFrameNumber = CurrentPlaybackStateObj.CurrentFrameNumber + 1;
        if (
          CurrentPlaybackStateObj.ElapsedTime / 1000 < CurrentPlaybackStateObj.CurrentScene.time &&
          !CurrentPlaybackStateObj.switchSceneForRecording
        ) {
          if (this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex]) {
            this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].durationRun = CurrentPlaybackStateObj.ElapsedTime / 1000;
          }
          if (
            CurrentPlaybackStateObj.CurrentScene['music-fade-out'] &&
            CurrentPlaybackStateObj.BackgroundMusic &&
            CurrentPlaybackStateObj.BackgroundMusic.volume > 0
          ) {
            var sceneProgress = CurrentPlaybackStateObj.ElapsedTime / 1000 / CurrentPlaybackStateObj.CurrentScene.time;
            let calculatedVol = (0.9 - sceneProgress).toFixed(2) * CurrentPlaybackStateObj.backgroundTrackVolume;
            CurrentPlaybackStateObj.BackgroundMusic.volume = calculatedVol < 0 ? 0 : calculatedVol;
          }
          if (
            CurrentPlaybackStateObj.CurrentBackGroundSource &&
            CurrentPlaybackStateObj.CurrentBackGroundSource.type === 'video' &&
            CurrentPlaybackStateObj.CurrentBackGroundSource.end &&
            CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.duration >
              CurrentPlaybackStateObj.CurrentBackGroundSource.end - CurrentPlaybackStateObj.CurrentBackGroundSource.start
          ) {
            if (
              CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime >=
              CurrentPlaybackStateObj.CurrentBackGroundSource.end
            ) {
              CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime =
                CurrentPlaybackStateObj.CurrentBackGroundSource.start;
              CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.play();
            }
          }
          if (
            CurrentPlaybackStateObj.sceneBackgroundSources.length > 1 &&
            CurrentPlaybackStateObj.CurrentBackgroundIndex != CurrentPlaybackStateObj.sceneBackgroundSources.length - 1 &&
            CurrentPlaybackStateObj.CurrentBackGroundSource.end &&
            CurrentPlaybackStateObj.ElapsedTime / 1000 >= CurrentPlaybackStateObj.CurrentBackGroundSource.endTime
          ) {
            //Set next background
            CurrentPlaybackStateObj = this.setNextBackground(CurrentPlaybackStateObj);
          }
          if (!this.forceCanvas) {
            //Scene Start Trnsition
            if (CurrentPlaybackStateObj.ElapsedTime / 1000 < 0.6) {
              this.SetStartTransition(CurrentPlaybackStateObj);
            } else {
              this.app.stage.filters = [];
            }
            if (CurrentPlaybackStateObj.CurrentScene.time - (currentDate - CurrentPlaybackStateObj.CurrentSceneStartTime) / 1000 < 0.6) {
              this.SetEndTransition(CurrentPlaybackStateObj, currentDate);
            }
          }
          if (CurrentPlaybackStateObj.CurrentScene && CurrentPlaybackStateObj.CurrentScene.recordTextAnimation) {
            //minimum subscene animation time 500 milliseconds
            var subsceneElapse = CurrentPlaybackStateObj.CurrentSubscene ? currentDate - CurrentPlaybackStateObj.CurrentSubsceneStartTime : 0;
            if (subsceneElapse > 500) {
              var isAnimationsOver = false;
              // CurrentPlaybackStateObj.TextAnimations.forEach(animation => {
              //   if (animation.ratio != 1) {
              //     isAnimationsOver = false;
              //     //break;
              //   }
              // });
              if (isAnimationsOver) {
                if (
                  CurrentPlaybackStateObj.CurrentScene.sub_scenes &&
                  CurrentPlaybackStateObj.CurrentScene.sub_scenes.length - 1 !== CurrentPlaybackStateObj.CurrentSubsceneIndex
                ) {
                  //is not last subscene
                  CurrentPlaybackStateObj.switchSubsceneForRecording = true;
                } else {
                  CurrentPlaybackStateObj.switchSceneForRecording = true;
                }
              }
            }
          }
          if (false && this.props.transcribePreview && CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime) {
            ///////////////////////////////////////////////////////////////////////////
            if (
              (this.videoJson.AdditionaldataForSceneGeneration.continueGetTimeMarkers &&
                this.index === this.videoJson.AdditionaldataForSceneGeneration.timeMarkers.length - 1) ||
              (this.videoJson.AdditionaldataForSceneGeneration.continueGetSubtitleSentence &&
                this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode &&
                (!this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.next ||
                  !this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.next.next))
            ) {
              //this.videoRef.pause();
              if (
                this.videoJson.AdditionaldataForSceneGeneration.continueGetTimeMarkers &&
                this.index === this.videoJson.AdditionaldataForSceneGeneration.timeMarkers.length - 1
              ) {
                this.videoJson.AdditionaldataForSceneGeneration.timeMarkersData = this.props.createTimeMarkersArrayForPreview(
                  this.videoJson.AdditionaldataForSceneGeneration.nextTimeMarkersIndex,
                  this.videoJson.AdditionaldataForSceneGeneration.getOnlyHighlightedSentenceMarkers
                );
                this.videoJson.AdditionaldataForSceneGeneration.getOnlyHighlightedSentenceMarkers =
                  this.videoJson.AdditionaldataForSceneGeneration.timeMarkersData.playOnlyHighlightSentence;
                if (this.videoJson.AdditionaldataForSceneGeneration.timeMarkersData.timeMarkers.length > 0) {
                  this.videoJson.AdditionaldataForSceneGeneration.timeMarkers = this.videoJson.AdditionaldataForSceneGeneration.timeMarkers.concat(
                    this.videoJson.AdditionaldataForSceneGeneration.timeMarkersData.timeMarkers
                  );
                  this.videoJson.AdditionaldataForSceneGeneration.nextTimeMarkersIndex =
                    this.videoJson.AdditionaldataForSceneGeneration.timeMarkersData.nextSentenceIndex;
                } else {
                  this.videoJson.AdditionaldataForSceneGeneration.continueGetTimeMarkers = false;
                }
              }
              if (
                this.videoJson.AdditionaldataForSceneGeneration.continueGetSubtitleSentence &&
                this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode &&
                (!this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.next ||
                  !this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.next.next)
              ) {
                this.videoJson.AdditionaldataForSceneGeneration.sentenceData = this.props.getSentenceListAndWordIdentifiersForPreview(
                  this.videoJson.AdditionaldataForSceneGeneration.nextSubtitleSentenceIndex,
                  this.videoJson.AdditionaldataForSceneGeneration.wordIdentifiers,
                  this.videoJson.AdditionaldataForSceneGeneration.getOnlyHighlightedSentenceSubtitles
                );
                this.videoJson.AdditionaldataForSceneGeneration.getOnlyHighlightedSentenceSubtitles =
                  this.videoJson.AdditionaldataForSceneGeneration.sentenceData.playOnlyHighlightSentence;
                if (this.videoJson.AdditionaldataForSceneGeneration.sentenceData.rootSentenceNode) {
                  this.videoJson.AdditionaldataForSceneGeneration.lastSentenceNode.next =
                    this.videoJson.AdditionaldataForSceneGeneration.sentenceData.rootSentenceNode;
                  this.videoJson.AdditionaldataForSceneGeneration.lastSentenceNode =
                    this.videoJson.AdditionaldataForSceneGeneration.sentenceData.lastSentenceNode;
                  this.videoJson.AdditionaldataForSceneGeneration.nextSubtitleSentenceIndex =
                    this.videoJson.AdditionaldataForSceneGeneration.sentenceData.nextSentenceIndex;
                } else {
                  this.videoJson.AdditionaldataForSceneGeneration.continueGetSubtitleSentence = false;
                }
              }
            }
            ///////////////////////////////////////////////////////////////////////////
            const currentTime = parseFloat(CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime.toFixed(2));
            const currentWords = this.videoJson.AdditionaldataForSceneGeneration.wordIdentifiers[parseInt(currentTime)];
            if (currentWords) {
              let word = null;
              for (let wordIndex = currentWords.length - 1; wordIndex > -1; wordIndex--) {
                if (currentTime >= currentWords[wordIndex]['start_time'] && currentTime <= currentWords[wordIndex]['end_time']) {
                  word = currentWords[wordIndex];
                  break;
                }
              }
              if (word && word !== this.videoJson.AdditionaldataForSceneGeneration.lastWord) {
                this.videoJson.AdditionaldataForSceneGeneration.text += ` ${word.word}`;
                //if (this.state.isPlaying) {
                this.props.markCurrentSpeakingWord(
                  word.word + '_' + word.wordIndex + '_' + word.sentenceIndex,
                  word.wordIndex,
                  word.sentenceIndex,
                  word['start_time']
                );
                //}
                this.videoJson.AdditionaldataForSceneGeneration.lastWord = word;
              }
            }
            if (this.videoJson.AdditionaldataForSceneGeneration.timeMarkers[this.index]) {
              if (this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode) {
                this.videoJson.AdditionaldataForSceneGeneration.previousSentenceNode =
                  this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode;
                this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode =
                  this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.next;
                while (this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode) {
                  if (
                    CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime >=
                    this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.sentence.startTime
                  ) {
                    this.videoJson.AdditionaldataForSceneGeneration.previousSentenceNode =
                      this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode;
                    this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode =
                      this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.next;
                    continue;
                  }
                  break;
                }
                this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode =
                  this.videoJson.AdditionaldataForSceneGeneration.previousSentenceNode;
              }
              if (
                this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode &&
                CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime >=
                  this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.sentence.startTime
              ) {
                this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode =
                  this.videoJson.AdditionaldataForSceneGeneration.currentSentenceNode.next;
              }
              if (
                CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.currentTime >=
                this.videoJson.AdditionaldataForSceneGeneration.timeMarkers[this.index].end - 0.15
              ) {
                if (this.index <= this.videoJson.AdditionaldataForSceneGeneration.timeMarkers.length - 1) {
                  this.index++;
                }
              }
            }
          }
          if (CurrentPlaybackStateObj.CurrentSubscene) {
            CurrentPlaybackStateObj.SubSceneElapsedTime = currentDate - CurrentPlaybackStateObj.CurrentSubsceneStartTime;
            if (
              CurrentPlaybackStateObj.SubSceneElapsedTime / 1000 < CurrentPlaybackStateObj.CurrentSubscene.time &&
              !CurrentPlaybackStateObj.switchSubsceneForRecording
            ) {
              if (
                this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex] &&
                this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].subscenes[CurrentPlaybackStateObj.CurrentSubsceneIndex]
              ) {
                this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].subscenes[CurrentPlaybackStateObj.CurrentSubsceneIndex].durationRun =
                  CurrentPlaybackStateObj.SubSceneElapsedTime / 1000;
                CurrentPlaybackStateObj.PartElapsedTime = currentDate - CurrentPlaybackStateObj.PartRecordingStartTime;
                if (
                  !this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].subscenes[CurrentPlaybackStateObj.CurrentSubsceneIndex].parts[
                    CurrentPlaybackStateObj.PartIndex
                  ]
                ) {
                  this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].subscenes[CurrentPlaybackStateObj.CurrentSubsceneIndex].parts.push(
                    {
                      index: CurrentPlaybackStateObj.PartIndex,
                      durationRun: CurrentPlaybackStateObj.PartElapsedTime / 1000,
                    }
                  );
                } else {
                  this.sceneDurationRun[CurrentPlaybackStateObj.CurrentSceneIndex].subscenes[CurrentPlaybackStateObj.CurrentSubsceneIndex].parts[
                    CurrentPlaybackStateObj.PartIndex
                  ].durationRun = CurrentPlaybackStateObj.PartElapsedTime / 1000;
                }
                if (CurrentPlaybackStateObj.PartElapsedTime / 1000 > RECORDING_PART_TIME) {
                  if (CurrentPlaybackStateObj.CurrentSubscene.time - CurrentPlaybackStateObj.SubSceneElapsedTime / 1000 > RECORDING_PART_TIME / 2) {
                    CurrentPlaybackStateObj.PartIndex = CurrentPlaybackStateObj.PartIndex + 1;
                  }
                }
              }
            } else {
              this.frameRecordingStartTime = null;
              CurrentPlaybackStateObj = this.setSubScene(CurrentPlaybackStateObj.CurrentSubsceneIndex + 1, CurrentPlaybackStateObj);
              if (
                CurrentPlaybackStateObj.CurrentLogoSprite &&
                CurrentPlaybackStateObj.CurrentScene.background.logo &&
                CurrentPlaybackStateObj.CurrentScene.background.logo.src &&
                CurrentPlaybackStateObj.CurrentScene.background.logo.src != '' &&
                !this.props.isTemplateGridPreview
              ) {
                CurrentPlaybackStateObj.CurrentLogoSprite.zIndex = 100;
                this.app.stage.addChild(CurrentPlaybackStateObj.CurrentLogoSprite);
              }
              this.playTextAnimations(CurrentPlaybackStateObj);
            }
          }

          //Capture preview frames
          if (this.recordVideo && CurrentPlaybackStateObj) {
            let subSceneIndex = CurrentPlaybackStateObj.CurrentSubsceneIndex || 0;
            let partIndex = CurrentPlaybackStateObj.PartIndex || 0;
            if (
              !this.props.webmrecording &&
              this.sceneFrames.length > 0 &&
              (this.sceneFrames[this.sceneFrames.length - 1].partIndex !== CurrentPlaybackStateObj.PartIndex ||
                this.sceneFrames[this.sceneFrames.length - 1].subSceneIndex !== subSceneIndex)
            ) {
              let uploadStartTime = Date.now();
              this.pauseAnimations(CurrentPlaybackStateObj);
              let success = await this.sendFramesToServer();
              if (!success) {
                return;
              }

              //CurrentPlaybackStateObj.CurrentSubsceneStartTime = Date.now();
              let uploadEndTime = Date.now();
              CurrentPlaybackStateObj.CurrentSceneStartTime = CurrentPlaybackStateObj.CurrentSceneStartTime + (uploadEndTime - uploadStartTime);
              CurrentPlaybackStateObj.CurrentSubsceneStartTime = CurrentPlaybackStateObj.CurrentSubsceneStartTime + (uploadEndTime - uploadStartTime);
              CurrentPlaybackStateObj.PartRecordingStartTime = Date.now();
              this.playAnimations(CurrentPlaybackStateObj);
            }
            if (this.animationRecordingEnabled) {
              if (window.seleniumRecordingVersion === 'v2') {
                window.framesCount = window.framesCount + 1;
                let frameFileName = `${window.framesCount.toString().padStart(6, '0')}.png`;
                this.offscreen.convertToBlob({ type: 'image/png' }).then(async (blob) => {
                  // Create a fetch request to send the blob
                  try {
                    if (window.FRAME_DOWNLOAD_URL) {
                      if (window.FRAME_DOWNLOAD_VERSION === 'v2') {
                        window.frameUploadTasks.push(
                          axios.post(`${window.FRAME_DOWNLOAD_URL}frame_${frameFileName}`, blob, {
                            headers: {
                              'Content-Type': 'application/octet-stream', // Specify the content type
                            },
                          })
                        );
                      }
                    } else {
                      await axios.post(`https://dev-api.pictorycontent.com/video-generation/temp/frame_${frameFileName}`, blob, {
                        headers: {
                          'Content-Type': 'image/png', // Specify the content type
                        },
                      });
                    }
                  } catch {}
                });
              } else {
                let bitmap = !this.props.webmrecording && !window.seleniumFrames ? this.offscreen.transferToImageBitmap() : null;
                let base64Image = window.seleniumFrames ? this.app.view.toDataURL('image/png') : null;
                let sceneFrame = {
                  sceneIndex: CurrentPlaybackStateObj.CurrentSceneIndex,
                  subSceneIndex: subSceneIndex,
                  partIndex: CurrentPlaybackStateObj.PartIndex,
                  frameNumber: CurrentPlaybackStateObj.CurrentFrameNumber,
                  bitmap,
                  base64Image,
                };
                this.sceneFrames.push(sceneFrame);
              }
              this.framesCount++;
            }
          }
        } else {
          // Scene Has Ended
          if (this.recordVideo) {
            window.recordingFramesCount = this.framesCount;
            console.log(`TOTAL_GENERATED_FRAMES - ${this.framesCount}`);
            console.log('SCENE_RECORDING_COMPLETED');
            let success = await this.sendFramesToServer();
            if (success) {
              try {
                if (window.frameUploadTasks && window.frameUploadTasks.length > 0) {
                  await Promise.allSettled(window.frameUploadTasks);
                }
              } catch {
              } finally {
                window.frameUploadTasks = [];
              }
              window.recordingEnded = true;
              console.log(`FRAMES_UPLOAD_COMPLETED`);
            } else {
              window.recordingError = `FRAMES_UPLOAD_ERROR`;
              console.log(`FRAMES_UPLOAD_ERROR`);
            }
            return;
          } else {
            TexturesMgmt.CreateTexturesFromScenes(
              CurrentPlaybackStateObj.scenes,
              CurrentPlaybackStateObj.CurrentSceneIndex + 1,
              CurrentPlaybackStateObj.CurrentSceneIndex + 11,
              this.loadedTextures
            );
          }
          if (this.state.isBuffering) {
            return null;
          }
          if (
            false &&
            this.props.transcribePreview &&
            this.props.createSceneForVideoGenerationJson &&
            this.videoJson.AdditionaldataForSceneGeneration &&
            CurrentPlaybackStateObj.scenes.length < this.videoJson.AdditionaldataForSceneGeneration.summaryJson.length
          ) {
            function removeBOMChar(text) {
              //Commented below code to support all unicode characters.
              /* if (text) {
                var output = "";
                for (var i = 0; i < text.length; i++) {
                  if (text.charCodeAt(i) <= 127 || ((161 <= text.charCodeAt(i)) && (text.charCodeAt(i) <= 187)) || text.charCodeAt(i) === 8216 || text.charCodeAt(i) === 8217) {
                    output += text.charAt(i);
                  }
                }
                return output;
              } */
              return text;
            }
            let scene = [];
            if (
              this.videoJson.AdditionaldataForSceneGeneration.startIndex + CurrentPlaybackStateObj.scenes.length <
              this.videoJson.AdditionaldataForSceneGeneration.summaryJson.length
            ) {
              await this.props.createSceneForVideoGenerationJson(
                this.videoJson.AdditionaldataForSceneGeneration.summaryJson,
                this.videoJson.AdditionaldataForSceneGeneration.startIndex + CurrentPlaybackStateObj.scenes.length,
                scene,
                this.videoJson.AdditionaldataForSceneGeneration.defaultIntroTimeInSec,
                this.videoJson.AdditionaldataForSceneGeneration.showOutroLogoBackground,
                this.videoJson.AdditionaldataForSceneGeneration.defaultOutroTimeInSec,
                this.videoJson.AdditionaldataForSceneGeneration.videoClips,
                this.videoJson.AdditionaldataForSceneGeneration.heightCoefficient,
                this.videoJson.AdditionaldataForSceneGeneration.showLogoOnTitle,
                this.videoJson.AdditionaldataForSceneGeneration.showLogonOnScenes,
                this.videoJson.AdditionaldataForSceneGeneration.videoWidth,
                this.videoJson.AdditionaldataForSceneGeneration.videoHeight,
                removeBOMChar
              );
              CurrentPlaybackStateObj.scenes.push(scene[0]);
            }
          }
          this.setScene(CurrentPlaybackStateObj.CurrentSceneIndex + 1, CurrentPlaybackStateObj, false);
          return null;
          // If CurrentPlaybackStateObj then next scene has started with the next request animation frame
          // Next scene has started
        }

        if (this.recordVideo) {
          requestAnimationFrame(async () => {
            this.animationRecordingEnabled = true;
            for (var i = 0; i < CurrentPlaybackStateObj?.displayItemVideos?.length; i++) {
              let element = CurrentPlaybackStateObj?.displayItemVideos[i];
              if (element?.texture?.baseTexture?.resource?.source?.play) {
                element.texture.baseTexture.resource.source.play();
              }
            }
            await this.RenderFrame(CurrentPlaybackStateObj);
          });
        } else {
          requestAnimationFrame(async () => await this.RenderFrame(CurrentPlaybackStateObj));
        }
      } else {
        this.pause(CurrentPlaybackStateObj, this.state.isBuffering);
      }
    }
  };

  async sendFramesToServer() {
    try {
      if (this.props.webmrecording) {
        await this.sleep(2000);
        this.streamRecorder.stop();
        //await this.sleep(2000);
        //console.log(`TOTAL_GENERATED_FRAMES - ${this.streamRecorder.recordedBlobs.length} and duration ${this.sceneDurationRun[0].durationRun.toFixed(2)}`);
        //console.log(`FRAMES_UPLOADED - ${1}`)
        //this.streamRecorder.save(`scene.webm`);
        this.streamRecorder = null;
      } else {
        console.log(`TOTAL_GENERATED_FRAMES - ${this.sceneFrames.length}`);
        let frame = 1;
        let framesToUpload = [];
        for (let i = 0; i < this.sceneFrames.length; i++) {
          let sceneFrame = this.sceneFrames[i];
          let sceneFramesDuration = this.sceneDurationRun[0].durationRun.toFixed(2);
          if (this.sceneDurationRun[0].subscenes[sceneFrame.subSceneIndex]) {
            sceneFramesDuration = this.sceneDurationRun[0].subscenes[sceneFrame.subSceneIndex].durationRun.toFixed(2);
          }
          let partFrameDuration = this.sceneDurationRun[0].durationRun.toFixed(2);
          if (
            this.sceneDurationRun[0].subscenes[sceneFrame.subSceneIndex] &&
            this.sceneDurationRun[0].subscenes[sceneFrame.subSceneIndex].parts[sceneFrame.partIndex]
          ) {
            partFrameDuration = this.sceneDurationRun[0].subscenes[sceneFrame.subSceneIndex].parts[sceneFrame.partIndex].durationRun.toFixed(2);
          }
          try {
            let frameFileName = `${frame.toString().padStart(15, '0')}_${sceneFrame.subSceneIndex.toString().padStart(4, '0')}_${sceneFrame.partIndex
              .toString()
              .padStart(4, '0')}_${partFrameDuration}.png`;

            if (window.seleniumFrames) {
              if (window.seleniumRecordingVersion !== 'v2') {
                window.seleniumFrames.push([frameFileName, sceneFrame.base64Image]);
                sceneFrame.base64Image = null;
              }
            } else {
              let offscreen = new OffscreenCanvas(sceneFrame.bitmap.width, sceneFrame.bitmap.height);
              const ctx = offscreen.getContext('bitmaprenderer');

              ctx.transferFromImageBitmap(sceneFrame.bitmap);
              let blob = await offscreen.convertToBlob();

              framesToUpload.push({
                frameFileName,
                blob,
              });
              if (framesToUpload.length === MAX_FPS || (framesToUpload.length > 0 && i === this.sceneFrames.length - 1)) {
                let form = new FormData();
                form.append('destination', this.props.framesdestination);
                for (let frameData of framesToUpload) {
                  form.append('files[]', frameData.blob, frameData.frameFileName);
                }
                let config = {
                  header: {
                    'Content-Type': 'multipart/form-data',
                  },
                };
                await axios.post('http://127.0.0.1:9090/api/v1/frame', form, config);

                framesToUpload = [];
              }
            }
            //let blobUrl = window.URL.createObjectURL(blob);
            //this.frameDownloadLink.href = blobUrl;
            //this.frameDownloadLink.download = frameFileName;
            //this.frameDownloadLink.click();
            //window.URL.revokeObjectURL(blobUrl);
          } catch (frameError) {
            window.recordingError = `FRAMES_CREATE_ERROR - ${frameError.message}`;
            console.log(`FRAMES_CREATE_ERROR - ${frameError.message}, frame - ${frame}`);
            await this.sleep(500);
            throw frameError;
          }
          //await this.sleep(500);
          /* let form = new FormData();
          form.append('file', blob, `${frame.toString().padStart(20, '0')}.png`);
          form.append("subsceneIndex", sceneFrame.subSceneIndex.toString().padStart(4, '0'));
          form.append("subsceneDuration", this.sceneDurationRun[0].subscenes[sceneFrame.subSceneIndex].durationRun.toFixed(2));
          let config = {
            header: {
              'Content-Type': 'multipart/form-data'
            }
          }
          await axios.post("http://localhost:9090/api/v1/frame", form, config); */
          window.recordingFramesUploadedCount = (window.recordingFramesUploadedCount || 0) + frame;
          console.log(`FRAMES_UPLOADED - ${frame}`);
          frame++;
        }
      }
    } catch (error) {
      window.recordingError = `FRAMES_UPLOAD_ERROR - ${error.message}`;
      console.log(`FRAMES_UPLOAD_ERROR - ${error.message}`);
      //ToDo let server know about error in sending frames
      return false;
    }
    this.sceneFrames = [];
    return true;
  }

  sleep = (milliseconds) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve('success'), milliseconds);
    });
  };

  pause(CurrentPlaybackStateObj, isBuffering = false) {
    if (CurrentPlaybackStateObj.Audio) {
      CurrentPlaybackStateObj.Audio.pause();
    }
    if (CurrentPlaybackStateObj.BackgroundMusic) {
      CurrentPlaybackStateObj.BackgroundMusic.pause();
    }
    if (
      CurrentPlaybackStateObj.CurrentBackGroundSource &&
      CurrentPlaybackStateObj.CurrentBackGroundSource.type === 'video' &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture
    ) {
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.pause();
      if (isBuffering) {
        //CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.addEventListener('canplaythrough',this.playOnReady.bind(this));
      }
    }
    this.pauseAnimations(CurrentPlaybackStateObj);
    this.pauseDisplayItems(CurrentPlaybackStateObj);
    //var currentDate = Date.now();
    //CurrentPlaybackStateObj.ElapsedTime = currentDate - CurrentPlaybackStateObj.CurrentSceneStartTime;
    //CurrentPlaybackStateObj.SubSceneElapsedTime = currentDate - CurrentPlaybackStateObj.CurrentSubsceneStartTime;
    this.pausedPlaybackState = CurrentPlaybackStateObj;
    if (this.state.gotoScenenumber !== -1) {
      var CurrentPlaybackStateObj = this.pausedPlaybackState;
      this.setScene(this.state.gotoScenenumber, CurrentPlaybackStateObj, true, true);
    }
  }

  pauseDisplayItems(CurrentPlaybackStateObj) {
    for (var i = 0; i < CurrentPlaybackStateObj?.displayItemVideos?.length; i++) {
      let element = CurrentPlaybackStateObj?.displayItemVideos[i];
      if (element?.texture?.baseTexture?.resource?.source?.pause) {
        element.texture.baseTexture.resource.source.pause();
      }
    }
  }

  pauseAnimations(CurrentPlaybackStateObj) {
    if (CurrentPlaybackStateObj && CurrentPlaybackStateObj.BackgroundAnimations) {
      CurrentPlaybackStateObj.BackgroundAnimations.forEach((animation) => {
        animation.pause();
      });
    }
    if (CurrentPlaybackStateObj && CurrentPlaybackStateObj.TextAnimations) {
      CurrentPlaybackStateObj.TextAnimations.forEach((animation) => {
        animation.pause();
      });
    }
  }

  SetEndTransition(CurrentPlaybackStateObj, currentDate) {
    if (CurrentPlaybackStateObj.CurrentScene['in-effect']) {
      var image = require(`./TransitionTemplates/` + CurrentPlaybackStateObj.CurrentScene['in-effect'] + '.jpg');
      var mask = PIXI.Sprite.from(image);
      var timeleft = CurrentPlaybackStateObj.CurrentScene.time - (currentDate - CurrentPlaybackStateObj.CurrentSceneStartTime) / 1000;
      var timedone = 0.6 - timeleft;
      var timeratiodone = timedone / 0.6;
      const TransitionFilter = new PIXI.Filter(null, SceneEndTransition);
      TransitionFilter.uniforms.uTextureOne = mask.texture;
      TransitionFilter.uniforms.progress = timeratiodone;
      this.app.stage.filters = [TransitionFilter];
    }
  }

  SetStartTransition(CurrentPlaybackStateObj) {
    if (CurrentPlaybackStateObj.CurrentScene['out-effect']) {
      var image = require(`./TransitionTemplates/` + CurrentPlaybackStateObj.CurrentScene['out-effect'] + '.jpg');
      var timeRatioDone = CurrentPlaybackStateObj.ElapsedTime / 1000 / 0.6;
      var mask = PIXI.Sprite.from(image);
      const TransitionFilter = new PIXI.Filter(null, SceneStartTransition);
      TransitionFilter.uniforms.uTextureOne = mask.texture;
      TransitionFilter.uniforms.progress = timeRatioDone;
      this.app.stage.filters = [TransitionFilter];
    }
  }

  GenerateBackgroundSprite(texture, width, height, mode, frame, scaleX, scaleY) {
    var Sprite = new PIXI.Sprite(texture);
    var scale = TexturesMgmt.GetTextureScale(texture, width, height, mode);
    Sprite.width = texture.width * scale;
    Sprite.height = texture.height * scale;

    if (width > Sprite.width) {
      Sprite.x = width / 2 - Sprite.width / 2;
      Sprite.y = height / 2 - Sprite.height / 2;
    } else {
      Sprite.x = width / 2 - Sprite.width / 2;
      Sprite.y = height / 2 - Sprite.height / 2;
    }
    if (frame) {
      Sprite.x = Sprite.x + frame.center_x * scaleX;
      Sprite.y = Sprite.y + frame.center_y * scaleY;
    }
    return Sprite;
  }
  GenerateLogoSprite(texture, width, height, position, location_y, scaleY, size, opacity, widthPercent, leftCoordinate, topCoordinate) {
    var Sprite = new PIXI.Sprite(texture);
    var logoScaleRation = texture.width / texture.height;
    if (size) {
      Sprite.width = size * width;
      Sprite.height = Sprite.width * (1 / logoScaleRation);
    } else {
      if (widthPercent) {
        Sprite.width = (parseFloat(widthPercent.replace('%', '')) / 100) * width;
      } else {
        Sprite.width = 0.1 * width;
      }
      Sprite.height = Sprite.width * (1 / logoScaleRation);
    }
    if (position === 'top-left') {
      Sprite.x = 0.02 * width;
      Sprite.y = 0.02 * height;
    } else if (position === 'top-right') {
      Sprite.x = width - Sprite.width - 0.01 * width;
      Sprite.y = 0.02 * height;
    } else if (position === 'top-center') {
      Sprite.x = width / 2 - Sprite.width / 2;
      Sprite.y = 0.02 * height;
    } else if (position === 'center-left') {
      Sprite.x = 0.02 * width;
      Sprite.y = height / 2 - Sprite.height / 2;
    } else if (position === 'center-center') {
      Sprite.x = width / 2 - Sprite.width / 2;
      Sprite.y = height / 2 - Sprite.height / 2;
    } else if (position === 'center-right') {
      Sprite.x = width - Sprite.width - 0.01 * width;
      Sprite.y = height / 2 - Sprite.height / 2;
    } else if (position === 'bottom-left') {
      Sprite.x = 0.02 * width;
      Sprite.y = height - 0.02 * height - Sprite.height;
    } else if (position === 'bottom-center') {
      Sprite.x = width / 2 - Sprite.width / 2;
      Sprite.y = height - 0.02 * height - Sprite.height;
    } else if (position === 'bottom-right') {
      Sprite.x = width - Sprite.width - 0.01 * width;
      Sprite.y = height - 0.02 * height - Sprite.height;
    } else if (position === 'center') {
      Sprite.x = width / 2 - Sprite.width / 2;
      if (location_y) {
        Sprite.y = location_y * scaleY;
      } else {
        Sprite.y = 0.02 * height;
      }
    } else {
      Sprite.x = width - Sprite.width - 0.01 * width;
      Sprite.y = 0.02 * height;
    }
    if (leftCoordinate && topCoordinate) {
      let left = (parseFloat(leftCoordinate.replace('%', '')) / 100) * width;
      let top = (parseFloat(topCoordinate.replace('%', '')) / 100) * height;
      Sprite.x = left;
      Sprite.y = top;
    }
    if (opacity && !Number.isNaN(opacity)) {
      Sprite.alpha = opacity;
    }
    return Sprite;
  }
  GenerateWatermarkSprite(texture, width, height, position) {
    var Sprite = new PIXI.Sprite(texture);
    var ScaleRatio = Sprite.width / Sprite.height;
    if (Sprite.height > (10 * height) / 100) {
      Sprite.height = (10 * height) / 100;
      Sprite.width = Sprite.height * ScaleRatio;
    }
    if (!position || position !== 'top-left') {
      Sprite.x = 0.03 * width;
      Sprite.y = 0.05 * height;
    } else {
      Sprite.x = width - Sprite.width - 0.03 * width;
      Sprite.y = 0.05 * height;
    }
    return Sprite;
  }
  GenerateBackgroundGraphic(backcolor, width, height, isMask = false) {
    let backGround = new PIXI.Graphics();
    var alphaVal = 1;
    if (backcolor) {
      if (backcolor.includes('rgba')) {
        var colorArray = backcolor.replace('rgba(', '').replace(')', '').split(',');
        alphaVal = parseInt(colorArray[3]) / 255;
        if (parseFloat(colorArray[3]) >= 0 && parseFloat(colorArray[3]) <= 1) {
          alphaVal = parseFloat(colorArray[3]);
        }
      } else {
        var colorArray = backcolor.replace('rgb(', '').replace(')', '').split(',');
      }
      var col = this.ConvertRGBtoHex(parseInt(colorArray[0]), parseInt(colorArray[1]), parseInt(colorArray[2]));
      if (!isMask) {
        backGround.beginFill(PIXI.utils.string2hex(col), 1);
      } else {
        backGround.beginFill();
      }
      backGround.drawRect(0, 0, width, height);
      backGround.endFill();
      backGround.alpha = alphaVal;
    }
    return backGround;
  }
  ColorToHex(color) {
    var hexadecimal = color.toString(16);
    return hexadecimal.length == 1 ? '0' + hexadecimal : hexadecimal;
  }

  ConvertRGBtoHex(red, green, blue) {
    return '#' + this.ColorToHex(red) + this.ColorToHex(green) + this.ColorToHex(blue);
  }
  CleanupScene(CurrentPlaybackStateObj) {
    if (
      CurrentPlaybackStateObj.CurrentBackGroundSource &&
      CurrentPlaybackStateObj.CurrentBackGroundSource.type === 'video' &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture &&
      CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture
    ) {
      //CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.removeEventListener('waiting',this.pauseOnWaiting.bind(this));
      //CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.removeEventListener('canplaythrough',this.playOnReady.bind(this));
      //CurrentPlaybackStateObj.CurrentBackgroundTexture.destroy(true);
      try {
        CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.removeAttribute('src');
        CurrentPlaybackStateObj.CurrentBackgroundTexture.baseTexture.resource.source.load();
        PIXI.Texture.removeFromCache(CurrentPlaybackStateObj.CurrentBackgroundTexture);
      } catch (e) {}
    }
    this.pauseDisplayItems(CurrentPlaybackStateObj);
    // if(CurrentPlaybackStateObj.CurrentBackGroundSource){

    //   TexturesMgmt.RemoveTexture(CurrentPlaybackStateObj.CurrentBackGroundSource);
    // }
    if (CurrentPlaybackStateObj.CurrentLogoSprite) {
      this.app.stage.removeChild(CurrentPlaybackStateObj.CurrentLogoSprite);
    }
    if (CurrentPlaybackStateObj.CurrentSceneContainer) {
      this.app.stage.removeChild(CurrentPlaybackStateObj.CurrentSceneContainer);
      CurrentPlaybackStateObj.CurrentSceneContainer.destroy({ children: true, texture: false, baseTexture: false });
    }
    CurrentPlaybackStateObj.BackgroundAnimations = [];
    CurrentPlaybackStateObj.switchSubsceneForRecording = false;
    CurrentPlaybackStateObj.switchSceneForRecording = false;
  }
  CleanupSubScene(CurrentPlaybackStateObj) {
    if (CurrentPlaybackStateObj.CurrentSubSceneContainer) {
      this.app.stage.removeChild(CurrentPlaybackStateObj.CurrentSubSceneContainer);
      CurrentPlaybackStateObj.CurrentSubSceneContainer.destroy({ children: true, texture: false, baseTexture: false });
    }
    this.pauseDisplayItems(CurrentPlaybackStateObj);
    CurrentPlaybackStateObj.TextAnimations = [];
    CurrentPlaybackStateObj.switchSubsceneForRecording = false;
    CurrentPlaybackStateObj.switchSceneForRecording = false;
    CurrentPlaybackStateObj.displayItemVideos = [];
  }
  LoadVideoPlaybackPopup = (element) => {
    //Programatically adding a canvas using default pixi view
    if (element && (!this.recordVideo || this.props.webmrecording) && this.app && this.app.view) {
      if (this.props.isTemplateGridPreview) {
        this.app.view.style.width = this.props.width + 'px';
      }
      element.appendChild(this.app.view);
    }
  };
  playVideo = () => {
    this.isPlaying = true;
    this.setState({ showPlay: false }, async () => {
      if (this.videoEnded === true) {
        this.isPlaying = false;
        while (this.app.stage.children.length > 0) {
          var child = this.app.stage.getChildAt(0);
          this.app.stage.removeChild(child);
        }
        this.playFromScene(0);
      } else {
        if (this.isPlaying) {
          let currentDate = Date.now();
          if (this.pausedPlaybackState.CurrentScene) {
            this.pausedPlaybackState.CurrentSceneStartTime = currentDate - this.pausedPlaybackState.ElapsedTime;
          }
          if (this.pausedPlaybackState.CurrentSubscene) {
            this.pausedPlaybackState.CurrentSubsceneStartTime = currentDate - this.pausedPlaybackState.SubSceneElapsedTime;
          }

          if (!this.recordVideo) {
            if (this.pausedPlaybackState.Audio) {
              this.pausedPlaybackState.Audio.play();
            }
            if (this.pausedPlaybackState.BackgroundMusic) {
              this.pausedPlaybackState.BackgroundMusic.play();
            }
          }
          if (
            this.pausedPlaybackState.CurrentBackGroundSource &&
            this.pausedPlaybackState.CurrentBackGroundSource.type === 'video' &&
            this.pausedPlaybackState.CurrentBackgroundTexture &&
            this.pausedPlaybackState.CurrentBackgroundTexture.baseTexture
          ) {
            //this.pausedPlaybackState.CurrentBackgroundTexture.baseTexture.resource.source.removeEventListener('canplaythrough',this.playOnReady.bind(this));
            this.pausedPlaybackState.CurrentBackgroundTexture.baseTexture.resource.source.play().then(async () => {
              this.setState({
                showPlay: false,
                isBuffering: false,
                gotoScenenumber: -1,
              });
              this.playAnimations(this.pausedPlaybackState);
              this.playDisplayItems(this.pausedPlaybackState);
              await this.RenderFrame(this.pausedPlaybackState);
              //this.isBuffering =false;
            });
          } else {
            this.playAnimations(this.pausedPlaybackState);
            this.playDisplayItems(this.pausedPlaybackState);
            await this.RenderFrame(this.pausedPlaybackState);
          }
        }
      }
    });
  };
  pauseVideo = () => {
    this.isPlaying = false;
    this.setState({ showPlay: true });
  };
  clearCanvas = () => {
    while (this.app.stage.children.length > 0) {
      var child = this.app.stage.getChildAt(0);
      this.app.stage.removeChild(child);
    }
  };

  handleClose = () => {
    // if(this.app){
    //   this.app.stop();
    // }
    clearCache();
    PIXI.Assets.reset();
    if (!this.props.isTemplateGridPreview) {
      this.isPlaying = false;
      if (this.globalCurrentPlaybackStateObj) {
        this.pause(this.globalCurrentPlaybackStateObj);
      }
      this.setState({ showPreview: false, gotoScenenumber: -1 }, () => {
        try {
          if (this.props.previewEnded) {
            this.props.previewEnded();
          }
          while (this.app.stage.children.length > 0) {
            var child = this.app.stage.getChildAt(0);
            this.app.stage.removeChild(child);
          }
          AudioRepository.clearCache();
          BackgroundMusicRepository.clearCache();
          if (this.globalCurrentPlaybackStateObj) {
            this.pause(this.globalCurrentPlaybackStateObj);
            if (this.globalCurrentPlaybackStateObj.CurrentSubSceneContainer) {
              this.globalCurrentPlaybackStateObj.CurrentSubSceneContainer.destroy({
                children: true,
                texture: true,
                baseTexture: true,
              });
            }
            if (this.globalCurrentPlaybackStateObj.CurrentSceneContainer) {
              this.globalCurrentPlaybackStateObj.CurrentSceneContainer.destroy({
                children: true,
                texture: true,
                baseTexture: true,
              });
            }
          }
          PIXI.utils.destroyTextureCache();
          this.app.destroy(true, { children: true, texture: true, baseTexture: true });
        } catch (e) {}
      });
    } else {
      while (this.app.stage.children.length > 0) {
        var child = this.app.stage.getChildAt(0);
        this.app.stage.removeChild(child);
      }
    }
  };
  playFromScene = (index) => {
    if (!this.state.isBuffering) {
      for (let i = 0; i < this.loadedTextures.length; i++) {
        var texture = this.loadedTextures.shift();
        try {
          texture.baseTexture.resource.source.removeAttribute('src');
          texture.baseTexture.resource.source.load();
          PIXI.Texture.removeFromCache(texture);
        } catch (e) {}
        //texture.destroy();
      }
      if (this.isPlaying && !this.videoEnded) {
        this.isPlaying = false;
        this.setState({ showPlay: false, gotoScenenumber: index });
      } else {
        this.isPlaying = false;
        this.setState({ showPlay: false, gotoScenenumber: index, isBuffering: true }, () => {
          this.setScene(this.state.gotoScenenumber, this.baseCurrentPlaybackStateObj, true, true);
        });
      }
    }
  };
  playDisplayItems(CurrentPlaybackStateObj) {
    for (var i = 0; i < CurrentPlaybackStateObj?.displayItemVideos?.length; i++) {
      let element = CurrentPlaybackStateObj?.displayItemVideos[i];
      if (element?.texture?.baseTexture?.resource?.source?.play) {
        element.texture.baseTexture.resource.source.play();
      }
    }
  }

  playAnimations(PlaybackState) {
    PlaybackState.BackgroundAnimations.forEach((animation) => {
      animation.play();
    });
    this.playTextAnimations(PlaybackState);
  }

  playTextAnimations(PlaybackState) {
    PlaybackState.TextAnimations.forEach((animation) => {
      animation.play();
    });
  }

  secondsToHms(d) {
    d = Number(d);
    if (d >= 3600) {
      return moment.utc(d * 1000).format('H:mm:ss');
    } else {
      return moment.utc(d * 1000).format('m:ss');
    }
  }

  render() {
    let seekContainer = document.querySelector('.video-seek-container');
    return (
      <>
        {this.state.showPreview ? (
          !this.props.singleScenePreview && !this.props.transcribePreview ? (
            <div className={'VideoProgressBar d-block'}>
              <Rnd
                className="drag-handle"
                default={{ x: this.props.defaultX, y: this.props.defaultY }}
                ref={(ref) => (this.rnd = ref)}
                bounds="parent"
                dragHandleClassName="drag-handle"
                cancel=".video-seek-container"
                enableResizing={false}
              >
                <div className="preview-container fit-content ">
                  {this.props.previewAlert}
                  <h4 className="modal-title text-left blue">Preview</h4>
                  <span id="closeIcon" className="close" onClick={this.handleClose}>
                    &times;
                  </span>
                  <div className="addl-txt mb-2">
                    <span className="small">The Storyblocks watermarks or any audio issue seen here will not be present in the final video.</span>
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Loader
                      type="ThreeDots"
                      color="Blue"
                      height={74}
                      width={74}
                      visible={this.state.isBuffering}
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: '999',
                        width: '74px',
                      }}
                    />
                    {this.state.showPlay && !this.props.isTemplateGridPreview && (
                      <span id="playButton" className="fa fa-play" onClick={this.playVideo}></span>
                    )}
                    {!this.state.showPlay && !this.props.isTemplateGridPreview && (
                      <span id="pauseButton" className="fa fa-pause" onClick={this.pauseVideo}></span>
                    )}
                    <div style={{ position: 'relative' }}>
                      <div>
                        <div id="blurBgDiv" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}></div>
                        <div
                          style={{
                            backdropFilter: !this.props.isTemplateGridPreview && !this.state.isAnimationPreview ? 'blur(8px)' : '',
                            display: 'inline-flex',
                          }}
                          ref={this.LoadVideoPlaybackPopup}
                        />
                      </div>
                      <div className="flex-row space-between-center sortof-black small p-1">
                        <div>{this.secondsToHms(this.state.timeDone)}</div>
                        <div>{this.secondsToHms(this.state.totalTime)}</div>
                      </div>
                      <div
                        className="video-seek-container"
                        onScroll={(e) => {
                          if (!this.state.windowBusy) {
                            let scrollLeft = e.target.scrollLeft;
                            let clientWidth = e.target.clientWidth;
                            window.requestAnimationFrame(() => {
                              this.counter = (this.counter || 0) + 1;
                              let startSubceneIndex = this.state.scrollLeftForSubscenes.findIndex((scrollVal) => scrollVal >= scrollLeft);
                              let endSubceneIndex = findLastIndex(
                                this.state.scrollLeftForSubscenes,
                                (scrollVal) => scrollVal <= scrollLeft + clientWidth
                              );
                              if (endSubceneIndex === -1) endSubceneIndex = this.state.scrollLeftForSubscenes.length - 1;
                              this.setState({
                                scrolling: true,
                                windowBusy: false,
                                scrollStartTime: new Date(),
                                startSubceneIndex,
                                endSubceneIndex,
                              });
                              setTimeout(() => {
                                if (new Date().getTime() - this.state.scrollStartTime.getTime() > 2000) this.setState({ scrolling: false });
                              }, 3000);
                            });
                            this.setState({ windowBusy: true });
                          }
                        }}
                      >
                        <div className="video-seekbar-spacer"></div>
                        <div className="progress" style={{ width: this.state.seekbarWidth }}>
                          <span
                            className="progress-bar progress-bar-grey progress-bar-second-transitions"
                            style={{ width: this.state.progress, transition: '0s' }}
                          ></span>
                        </div>
                        <div className="progress video-seek-bar" style={{ width: this.state.seekbarWidth }}>
                          {this.state.timeLineArrayElements.map((sceneObj, i) =>
                            sceneObj.subScenes.map((subScene, j) => {
                              return (
                                <>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="seekbar-scene-number">
                                        <span>{subScene.showSceneNumber}</span>
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      className={
                                        'slide-marker' +
                                        (i === this.state.timeLineArrayElements.length - 1 && j === sceneObj.subScenes.length - 1
                                          ? ''
                                          : j === sceneObj.subScenes.length - 1
                                          ? ' solid-line'
                                          : ' dotted-line')
                                      }
                                      data-sceneindex={i}
                                      onClick={() => this.playFromScene(sceneObj.index)}
                                      style={{
                                        width:
                                          this.state.seekbarWidth === '100%' ? subScene.percentage : subScene.time * SCENE_TIME_PX_MULTIPLIER + 'px',
                                      }}
                                    ></span>
                                  </OverlayTrigger>
                                </>
                              );
                            })
                          )}
                        </div>
                        <Overlay target={seekContainer} show={this.state.scrolling} placement="top">
                          {(props) => {
                            props = { ...props, style: { ...props.style, bottom: '-33px' } };
                            return (
                              <Tooltip id="scene-range-tooltip" {...props}>
                                <div className="seekbar-tooltip-content flex-row space-around-center">
                                  <i className="fa fa-arrow-left font-size-xs" />
                                  <strong>
                                    &nbsp;&nbsp;Scene {this.state.startSubceneIndex + 1}... Scene {this.state.endSubceneIndex + 1}&nbsp;&nbsp;
                                  </strong>
                                  <i className="fa fa-arrow-right font-size-xs" />
                                </div>
                              </Tooltip>
                            );
                          }}
                        </Overlay>
                      </div>
                    </div>
                  </div>
                </div>
                {this.props.showAutoSyncVoiceoverButtons && (
                  <div className="flex-centered" style={{ pointerEvents: 'auto' }}>
                    <button className="btn btn-span button-rounded green-background pointer" onClick={this.handleClose.bind(this)}>
                      Looks good
                    </button>
                    <button
                      className="btn ml-4 btn-span button-rounded white-background pointer"
                      onClick={() => {
                        this.handleClose();
                        this.props.toggleAudioTrimmer(true);
                      }}
                    >
                      Adjust
                    </button>
                  </div>
                )}
              </Rnd>
            </div>
          ) : this.state.startScene || this.props.transcribePreview ? (
            <div style={{ position: 'relative', zIndex: 8 }} className="preview-container">
              <Loader
                type="ThreeDots"
                color="Blue"
                height={74}
                width={74}
                visible={this.state.isBuffering}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: '999',
                  width: '74px',
                }}
              />
              {this.state.showPlay && !this.props.isTemplateGridPreview && !this.props.transcribePreview && (
                <span id="playButton" className="fa fa-play" onClick={this.playVideo}></span>
              )}
              {!this.state.showPlay && !this.props.isTemplateGridPreview && !this.props.transcribePreview && (
                <span id="pauseButton" className="fa fa-pause" onClick={this.pauseVideo}></span>
              )}
              <div id="blurBgDiv" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}></div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter:
                    !this.props.isTemplateGridPreview && !this.props.transcribePreview && !this.state.isAnimationPreview ? 'blur(8px)' : '',
                }}
                ref={this.LoadVideoPlaybackPopup}
              />
            </div>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </>
    );
  }
}
